export const kk = {
  'nav.catalog': 'Каталог',
  'nav.tender': 'Тендер',
  'nav.login': 'Кіру',
  'nav.dashboard': 'Басқару тақтасы',
  'nav.signOut': 'Шығу',
  'landing.hero.title': 'Іскерлік мүмкіндіктерді табыңыз',
  'landing.hero.description':
    'Ел бойынша мемлекеттік тендерлерді қараңыз. Аймақ, санат және мәртебе бойынша сүзіңіз.',
  'landing.hero.browseCatalog': 'Каталогты ашу',
  'landing.recentTenders': 'Соңғы тендерлер',
  'catalog.title': 'Тендерлер каталогы',
  'catalog.loading': 'Тендерлер жүктелуде…',
  'catalog.sourceStale':
    'Дереккөз алаңы {{date}} бастап жаңа тендерлер жарияламайды. Соңғы қолжетімді тендерлерді көрсетеміз.',
  'error.title': 'Жүктеу мүмкін болмады. Байланысты тексеріңіз.',
  'error.retry': 'Қайталау',
  'error.searchBusy':
    'Қазір сайтта бір уақытта іздеу тым көп. Сайт жұмыс істеп тұр: бірнеше секундтан кейін қайталаңыз.',
  'error.searchTooMany': 'Алдыңғы іздеулеріңіз әлі орындалуда. Нәтижесін күтіп, қайталаңыз.',
  'catalog.slowLoad':
    'Іздеу әдеттегіден ұзағырақ жүріп жатыр. Сайт жұмыс істеп тұр, нәтижелер бірнеше секундта шығады.',
  'catalog.filters': 'Сүзгілер',
  'catalog.filters.a11yDesc': 'Тендерлер каталогының сүзгілері.',
  'catalog.filtersApply': 'Нәтижелерді көрсету',
  'catalog.export': 'Excel-ге экспорттау',
  'catalog.exportProOnly': 'Экспорт Pro тарифінде қолжетімді',
  'catalog.exportFailed': 'Жүктеп алу мүмкін болмады. Қайталап көріңіз.',
  'catalog.found': 'Табылды: {{count}} тендер',
  'catalog.ikpuLabel': 'Тауар коды',
  'catalog.ikpuAll': 'Барлық санаттар',
  'catalog.sortLabel': 'Сұрыптау',
  'catalog.sort.newest': 'Алдымен жаңалары',
  'catalog.sort.deadline': 'Мерзімі жақын',
  'catalog.sort.budgetDesc': 'Бюджет: кемуі бойынша',
  'catalog.sort.budgetAsc': 'Бюджет: өсуі бойынша',
  'catalog.budgetFrom': 'Бюджет, бастап ({{currency}})',
  'catalog.budgetTo': 'Бюджет, дейін ({{currency}})',
  'catalog.deadlineFrom': 'Мерзімі, бастап',
  'catalog.excludeWords': 'Осы сөздер бар тендерлерді көрсетпеу',
  'catalog.excludeWordsPlaceholder': 'үтірмен бөліңіз',
  'catalog.deadlineTo': 'Мерзімі, дейін',
  'catalog.clearFilters': 'Сүзгілерді тазалау',
  'catalog.moreFilters': 'Тағы сүзгілер',
  'tender.backToIfi': '← ХҚМ жобаларына оралу',
  'tender.backToCatalog': '← Каталогқа оралу',
  'tender.loading': 'Тендер жүктелуде…',
  'tender.sourceLangNote': 'дереккөз тілінде',
  'tender.scanNotice':
    'Құжат сканынан танылды. Сомаларды, мерзімдерді, мекенжайларды және деректемелерді {{original}} салыстырыңыз.',
  'tender.scanNoticeOriginal': 'түпнұсқамен',
  'tender.notFound': 'Тендер табылмады',
  'tender.notFoundDesc': 'Мүмкін, ол жойылған немесе сілтеме ескірген.',
  'tender.loadFailed': 'Тендерді жүктеу мүмкін болмады',
  'tender.loadFailedDesc': 'Байланысты тексеріп, қайталап көріңіз.',
  'tender.seoDesc':
    '«{{title}}» тендері — {{countryPrep}} өзекті мемлекеттік сатып алуы. Бюджет, өтінім беру мерзімдері, талаптар және тапсырыс берушінің байланыстары — {{brand}} сайтында.',
  'tender.seoDescDefault':
    '{{countryGen}} тендерлері мен мемлекеттік сатып алулары: бюджеттер, өтінім беру мерзімдері және тапсырыс берушілердің байланыстары {{brand}} сайтында.',
  'tender.facts.lead': '{{countryPrep}} «{{title}}» мемлекеттік сатып алуы.',
  'tender.facts.region': 'Өткізу аймағы — {{region}}.',
  'tender.facts.budget': 'Бастапқы (ең жоғары) сома — {{budget}} {{currency}}.',
  'tender.facts.category': 'Санаты: {{category}}.',
  'tender.facts.deadline': 'Өтінімдер {{deadline}} дейін қабылданады.',
  'tender.facts.published': 'Жарияланды: {{published}}.',
  'tender.facts.docs': 'Сатып алуға тендерлік құжаттама тіркелген ({{count}} файл).',
  'tender.facts.label': 'Сатып алу туралы қысқаша',
  'tender.outcome.label': 'Сатып алу қорытындысы',
  'tender.outcome.winner': 'Жеңімпаз',
  'tender.outcome.winnerContact': 'Жеңімпаздың байланыстары',
  'tender.outcome.winnerContactCapped':
    'Бүгінгі лимитіңіз — 200 компания — таусылды. Біз әдеттен тыс белсенділікті байқадық. Лимитті алып тастау үшін қолдау қызметіне жазыңыз',
  'tender.outcome.winnerContactCappedTelegram': 'Telegram-ға жазу',
  'companyData.link': 'Бұл сіздің компанияңыз ба? Телефонды жасыру немесе деректерді түзету',
  'support.companyData.topic': 'Тақырып: компания деректері, БСН/ЖСН {{tin}}',
  'support.companyData.prefill': 'Компания деректері, БСН/ЖСН {{tin}}. ',
  'tender.buyer.profileLink': 'Тапсырыс берушінің профилі және барлық тендерлері →',
  'tender.outcome.finalPrice': 'Түпкілікті баға',
  'tender.outcome.awardedAt': 'Шешім қабылданған күн',
  'tender.outcome.failed': 'Сатып алу өтпеді',
  'tender.outcome.cancelled': 'Сатып алу тоқтатылды',
  'tender.outcome.noBids': 'Өтінімдер болған жоқ',
  'tender.outcome.notAwarded': 'Жеңімпаз анықталмады — сатып алу өтпеді',
  'tender.outcome.locked': 'Жеңімпаз анықталды. Аты, сома және байланысы — Pro-да',
  'tender.outcome.lockedCta': 'Pro рәсімдеу',
  'tender.outcome.lockedContactOnly': 'Жеңімпаз анықталды. Аты мен байланысы — Pro-да',
  'tender.outcome.lockedPriceOnly': 'Жеңімпаз анықталды. Аты мен сомасы — Pro-да',
  'tender.outcome.lockedWhoOnly': 'Жеңімпаз анықталды. Аты — Pro-да',
  'tender.outcome.lockedRow': 'Жеңімпаз, сома және байланыс — Pro-да',
  'tender.outcome.lockedRowContact': 'Жеңімпаз және оның байланысы — Pro-да',
  'tender.outcome.lockedRowPrice': 'Жеңімпаз бен сома — Pro-да',
  'tender.outcome.lockedRowWho': 'Жеңімпаз — Pro-да',
  'tender.nav.siblings': 'Басқа лоттар',
  'tender.siblings.headline': 'Осы хабарландыруда тағы {{count}} {{lots}}, жалпы {{amount}}',
  'tender.siblings.headlineNoSum': 'Осы хабарландыруда тағы {{count}} {{lots}}',
  'tender.siblings.hint': 'Өтінімді олардың кез келгеніне беруге болады — әр лотқа бөлек.',
  'tender.siblings.more': '+{{count}} тағы',
  'tender.contactInfo': 'Байланыс ақпараты',
  'tender.contactDetails': 'Байланыс деректері тіркелген пайдаланушыларға қолжетімді.',
  'tender.contactDetailsAuthed': 'Тапсырыс берушінің байланыстарын көру үшін ашыңыз.',
  'tender.opening': 'Ашылуда…',
  'tender.contactName': 'Байланыс тұлғасы',
  'tender.contactEmail': 'Email',
  'tender.contactPhone': 'Телефон',
  'tender.contactCategory': 'Қызмет түрі',
  'tender.contactWebsite': 'Сайт',
  'tender.contactTelegram': 'Telegram',
  'tender.contactMapAddress': 'Картадағы мекенжай',
  'tender.sourceLabel': 'Бастапқы дереккөз',
  'tender.openOriginal': 'Тендердің түпнұсқасын ашу',
  'tender.participateHint': 'Өтінімді қалай беру керек және ЭЦҚ қалай алу керек',
  'tender.openOriginalCoop': 'Алаңдағы түпнұсқаны ашу',
  'tender.documentsLabel': 'Тендерлік құжаттама',
  'tender.originalTitle': 'Түпнұсқа атауы: {{title}}',
  'tender.docsTeaser.tz': 'Техникалық тапсырма',
  'tender.docsTeaser.contract': 'Шарт жобасы',
  'tender.docsTeaser.spec': 'Спецификация',
  'tender.docsTeaser.cta': 'Құжаттарды ашу',
  'tender.docsTeaser.meteredCta': 'Құжаттар алаңда — сілтемені ашу ({{count}} ішінен 1)',
  'tender.docsTeaser.meteredHint':
    'Файлдар алаңда. Ашу түпнұсқаға сілтеме мен тапсырыс берушінің байланыстарын береді — төмендегі түймемен бірдей әрекет.',
  'tender.docsTeaser.meteredOpenedCta': 'Құжаттар алаңда — түпнұсқаны ашу',
  'tender.procedureLabel': 'Өткізу тәртібі',
  'tender.procedure.method': 'Рәсім түрі',
  'tender.procedure.obligationTerm': 'Міндеттемелерді орындау мерзімі',
  'tender.procedure.serviceType': 'Жұмыс түрі',
  'tender.procedure.financialSource': 'Қаржыландыру көзі',
  'tender.procedure.address': 'Мекенжай',
  'tender.procedure.deliveryAddress': 'Жеткізу мекенжайы',
  'tender.procedure.decree': 'Негіздеме',
  'tender.procedure.discussionStart': 'Талқылаудың басталуы',
  'tender.procedure.discussionEnd': 'Талқылаудың аяқталуы',
  'tender.procedure.published': 'Жариялау күні',
  'tender.procedure.positions': 'Позициялар',
  'tender.procedure.positionsHint':
    'Осы лоттағы әртүрлі тауар, жұмыс немесе қызмет саны. Тапсырыс беруші оларды бір сатып алумен алады, өтінім бүкіл лотқа беріледі.',
  'tender.procedure.docsDeadline': 'Сұрақтар мен қарсылықтар мерзімі',
  'tender.procedure.opening': 'Ұсыныстарды ашу күні',
  'tender.procedure.announcementName': 'Хабарландыру',
  'tender.procedure.announcementNumber': 'Хабарландыру нөмірі',
  'tender.procedure.subjectKind': 'Сатып алу нысанасының түрі',
  'tender.procedure.planType': 'Жоспар тармағының түрі',
  'tender.procedure.organizer': 'Ұйымдастырушы',
  'tender.procedure.representative': 'Тапсырыс берушінің өкілі',
  'tender.procedure.bidStart': 'Өтінімдерді қабылдаудың басталуы',
  'tender.procedure.vatNote': 'Белгілер',
  'tender.procedure.commission': 'Конкурстық комиссия',
  'tender.procedure.sourceUpdated': 'Дереккөзде жаңартылды',
  'tender.contactNone': 'Бұл тендер үшін байланыс деректері көрсетілмеген.',
  'tender.insufficientAllowance':
    'Байланыстарды ашу лимиті таусылды. Тарифті жаңартыңыз немесе қосымша сатып алыңыз.',
  'tender.nicheRequired': 'Тапсырыс берушілердің байланыстары Pro тарифінде қолжетімді.',
  'tender.proRequired':
    'Бұл тендер сіздің нишаңыздан тыс. Барлық тендерлер бойынша байланыстарды ашу үшін Pro тарифіне өтіңіз.',
  'tender.revealError': 'Байланысты ашу мүмкін болмады. Кейінірек қайталап көріңіз.',
  'tender.upgradeCta': 'Тарифтерді қарау',
  'region.backToCatalog': '← Каталогқа оралу',
  'region.title': '{{region}} тендерлері',
  'region.loading': 'Жүктелуде…',
  'region.found': 'Табылды: {{count}} тендер',
  'region.seoTitle': '{{region}} тендерлері мен мемлекеттік сатып алулары',
  'region.seoTitlePaged': '{{region}} тендерлері — {{page}}-бет',
  'region.seoDesc':
    '{{region}} өзекті тендерлері мен мемлекеттік сатып алулары: {{count}} белсенді. Бюджеттер, өтінім беру мерзімдері және тапсырыс берушілердің байланыстары — {{brand}} сайтында.',
  'region.seoDescPaged':
    '{{region}} тендерлері мен мемлекеттік сатып алулары — {{totalPages}} беттің {{page}}-і, барлығы {{count}} белсенді. Бюджеттер, өтінім беру мерзімдері және тапсырыс берушілер — {{brand}} сайтында.',
  'region.intro':
    '{{region}} мемлекеттік тендерлері мен сатып алулары: қазір {{count}} белсенді. Әрқайсысы бойынша бюджет, өтінім беру мерзімі және орыс тіліндегі қысқаша сипаттама қолжетімді. Санат бойынша сүзіңіз, іздеуді сақтаңыз және жаңа тендерлерді поштаңызға немесе Telegram-ға алыңыз.',
  'category.backToCatalog': '← Каталогқа оралу',
  'category.title': 'Тендерлер: {{category}}',
  'category.loading': 'Жүктелуде…',
  'category.found': 'Табылды: {{count}} тендер',
  'category.topBuyers': 'Бұл санаттағы үздік тапсырыс берушілер',
  'category.seoTitle': 'Тендерлер мен сатып алулар: {{category}}',
  'category.seoTitlePaged': 'Тендерлер: {{category}} — {{page}}-бет',
  'category.seoDesc':
    '{{countryPrep}} «{{category}}» бағыты бойынша тендерлер мен мемлекеттік сатып алулар: {{count}} белсенді. Бюджеттер, мерзімдер және тапсырыс берушілер — {{brand}} сайтында.',
  'category.seoDescPaged':
    '{{countryPrep}} «{{category}}» бағыты бойынша тендерлер — {{totalPages}} беттің {{page}}-і, барлығы {{count}} белсенді. Бюджеттер, мерзімдер және тапсырыс берушілер — {{brand}} сайтында.',
  'category.intro':
    '«{{category}}» — {{countryPrep}} мемлекеттік сатып алуларының бір бағыты. Қазір каталогта осы санаттың {{count}} өзекті тендері бар: әрқайсысында бастапқы сома, өтінім беру мерзімі және орыс тіліндегі қысқаша сипаттама көрсетілген. Каталогта аймақты нақтылаңыз, іздеуді сақтаңыз және жаңа сатып алуларды поштаңызға немесе Telegram-ға алыңыз.',
  'guide.backToCatalog': '← Каталогқа оралу',
  'guide.seriesHeading': 'Брокерсіз тендер: қадам-қадаммен',
  'guide.articlesHeading': 'Тақырып бойынша мақалалар',
  'guide.nicheGuidesHeading': 'Нишалар бойынша нұсқаулықтар',
  'guide.answersHeading': 'Қысқа жауаптар',
  // Spain only (MiLicita «Casos reales» hub group); kept for key parity.
  'guide.casesHeading': 'Нақты сатып алулар талдауы',
  'guide.relatedHeading': 'Тақырып бойынша тағы',
  'guide.allArticles': 'Нұсқаулықтың барлық мақалалары',
  'login.title': 'Кіру',
  'login.subtitle': '{{brand}} сайтына қош келдіңіз.',
  'checkout.identify.emailHint': 'Жазылымға қол жеткізу осы мекенжайға келеді.',
  'checkout.identify.didYouMean': '{{email}} дегіңіз келді ме?',
  'checkout.identify.emailExample': 'Мысалы: ism@gmail.com',
  'login.telegramWhy': 'Telegram арқылы жылдам кіру — тіркелудегідей.',
  'login.email': 'Email',
  'login.password': 'Құпия сөз',
  'login.signingIn': 'Кіру…',
  'login.signIn': 'Кіру',
  'login.continue': 'Жалғастыру',
  'login.codeTitle': 'Кодты енгізіңіз',
  'login.codePrefilled': 'Хаттағы код автоматты түрде енгізілді',
  'login.subtitleFor': 'Тіркелгіге кіру',
  'login.or': 'немесе',
  'login.noAccount': 'Тіркелгіңіз жоқ па?',
  'login.signUp': 'Тіркелгі жасау',
  'register.title': 'Тіркелу',
  'register.subtitle': '{{brand}} сайтында тіркелгі жасаңыз.',
  'register.consentPrefix': 'Аккаунт жасай отырып, сіз',
  'register.pendingSearch': 'Тіркелгеннен кейін «{{name}}» іздеуін сақтаймыз',
  'register.name': 'Аты',
  'register.phone': 'Телефон',
  'register.phonePlaceholder': '+7 701 234 56 78',
  'register.phoneInvalid': 'Дұрыс нөмірді енгізіңіз, мысалы +7 701 234 56 78',
  'register.emailRequired': 'Email енгізіңіз',
  'register.codeIncomplete': '6 таңбалы кодты енгізіңіз',
  'register.tin': 'БСН/ЖСН',
  'register.tinOptional': 'Міндетті емес',
  'register.tinHint': '{{tinDigits}} сан — сіз жеңген тендерлерді көрсетеміз (міндетті емес)',
  'register.tinInvalid': 'БСН/ЖСН дәл {{tinDigits}} саннан тұруы керек',
  'register.email': 'Email',
  'register.sendCode': 'Кодты алу',
  'register.sendingCode': 'Жіберілуде…',
  'register.codeSentTo': 'Кодты мына мекенжайға жібердік:',
  'register.code': 'Хаттағы код',
  'register.codeHint': 'Код 10 минут жарамды. Келмесе, «Спам» қалтасын тексеріңіз.',
  'auth.otp.resend': 'Кодты қайта жіберу',
  'auth.otp.resendIn': 'Кодты {{seconds}} секундтан кейін қайта жіберуге болады',
  'auth.otp.notArrived': 'Коды бар хат келмеді ме?',
  'register.emailDidYouMean': 'Мынаны айтқыңыз келді ме',
  'register.icloudSpam':
    'iCloud поштасы біздің хаттарды жиі «Спам» қалтасына жібереді — қалтаны тексеріңіз. Немесе жоғарыдағы Telegram арқылы кіріңіз — бұл жылдамырақ.',
  'register.changeEmail': 'Басқа мекенжай көрсету',
  'register.editEmail': 'Өзгерту',
  'register.telegramWhy':
    'Тендерлер туралы хабарландырулар Telegram арқылы келеді — солай олар бірден қосылады.',
  'register.password': 'Құпия сөз',
  'register.passwordHint': 'Кемінде 8 таңба',
  'register.creating': 'Жасалуда…',
  'register.createAccount': 'Тіркелгі жасау',
  'register.haveAccount': 'Тіркелгіңіз бар ма?',
  'register.signIn': 'Кіру',
  'auth.error.emailTaken': 'Бұл email бұрыннан тіркелген. Тіркелгіге кіріңіз.',
  'auth.error.invalidCredentials': 'Email немесе құпия сөз қате.',
  'auth.error.generic': 'Бірдеңе дұрыс болмады. Қайталап көріңіз.',
  'auth.error.emailSyntax':
    'Пошта мекенжайын тексеріңіз — онда қате бар сияқты (мысалы, .com немесе .kz жоқ)',
  'onboarding.banner.title': 'Профильді баптау: {{total}}-дің {{done}}-і',
  'onboarding.banner.titleShort': 'Профиль: {{total}}-дің {{done}}-і',
  'onboarding.banner.show': 'Көрсету',
  'onboarding.banner.hide': 'Жасыру',
  'onboarding.banner.go': 'Қосу',
  'onboarding.banner.search': 'Сақталған іздеу',
  'onboarding.banner.telegram': 'Хабарландырулар',
  'onboarding.banner.inn': 'Компанияның БСН/ЖСН',
  'onboarding.banner.email': 'Поштаны растау',
  'onboarding.banner.activate': 'Көрсету',
  'onboarding.banner.noInn': 'Кейінірек',
  'onboarding.banner.emailWhy':
    'Поштаңызды растаңыз — осылайша аккаунтыңыз қорғалады және жаңа тендерлер туралы хабарландыру аласыз',
  'onboarding.banner.emailWhyShort': 'Іріктемелер поштаға келуі үшін.',
  'onboarding.verifyEmail.send': 'Кодты жіберу',
  'onboarding.verifyEmail.verify': 'Растау',
  'onboarding.inn.title': 'Ұйымыңыздың атауы немесе БСН/ЖСН?',
  'onboarding.inn.subtitle':
    'Компанияңыз бұрын не жеңгенін және саласыңызда қазір қанша тендер ашық екенін көрсетеміз.',
  'onboarding.inn.skip': 'Өткізіп жіберу',
  'onboarding.inn.digitsHint': 'Дәл {{digits}} сан керек',
  'onboarding.inn.next': 'Келесі',
  // Company step, Spain only (`features.aiCompanyStep`); kept for key parity.
  'onboarding.companyCodes.offer':
    'Бұрынғы келісімшарттарыңыздың кодтарын жазылымға қосыңыз: {{names}}.',
  'onboarding.companyCodes.more': 'тағы {{n}}',
  'onboarding.companyCodes.add': 'Жазылымға қосу',
  'onboarding.companyCodes.adding': 'Қосылуда…',
  'onboarding.companyCodes.added': 'Жазылымға қосылды.',
  'onboarding.companyCodes.addedSome':
    '{{total}} кодтың {{added}} қосылды: жазылымда {{max}} кодтан көп болмайды.',
  'onboarding.companyCodes.error': 'Қосу мүмкін болмады. Қайталап көріңіз.',
  'auth.error.passwordRequired': 'Құпиясөзді енгізіңіз',
  'auth.error.invalidCode':
    'Код келмеді: ол ескірген немесе оны жаңасы алмастырған болуы мүмкін. Жаңа код сұраңыз.',
  'auth.error.invalidPhone': 'Телефон нөмірін тексеріңіз.',
  'dashboard.title': '{{brand}} — басқару тақтасы',
  'dashboard.signedInAs': 'Сіз {{email}} ретінде кірдіңіз.',
  'dashboard.signOut': 'Шығу',
  'seo.landing.title': '{{brand}} — Іскерлік мүмкіндіктерді табыңыз',
  'seo.landing.description': 'Ел бойынша мемлекеттік тендерлерді қараңыз.',
  'seo.catalog.title': '{{countryGen}} тендерлері мен мемлекеттік сатып алулары',
  'seo.catalog.description':
    '{{countryGen}} мемлекеттік тендерлері мен сатып алулары каталогы: өзекті сатып алулар, орыс тіліндегі қысқаша сипаттамалар, аймақ пен санат бойынша сүзгілер, поштаға және Telegram-ға хабарландырулар — {{brand}} сайтында.',
  'seo.catalog.titlePaged':
    '{{countryGen}} тендерлері мен мемлекеттік сатып алулары — {{page}}-бет',
  'seo.results.title': '{{countryGen}} тендер нәтижелері: жеңімпаздар мен бағалар',
  'seo.results.titlePaged': '{{countryGen}} тендер нәтижелері — {{page}}-бет',
  'seo.results.description':
    '{{countryGen}} қорытындыланған сатып алулар мұрағаты: кім жеңді, қандай бағамен және қанша қатысушымен. 3 900-ден астам ойналған лот — {{brand}} сайтында.',
  'results.page.h1': 'Тендер нәтижелері',
  'results.page.intro':
    'Жеңімпазы жарияланған және түпкілікті бағасы белгілі аяқталған сатып алулар. Баға бағдарлары мен бәсекелестерді тексеру үшін дереккөз.',
  // ── /results card «Что вы поставляете?» (feat/results-search, 2026-10-07) ──
  'results.card.title': 'Не жеткізесіз?',
  'results.card.sub': 'Мұндай сатып алуларда кім жеңгенін көрсетеміз.',
  'results.card.placeholder': 'күріш, ұн, сорғылар…',
  'results.card.inputLabel': 'Сөздер, санаттар және ЕНС ТРУ кодтары',
  'results.card.remove': '«{{label}}» алып тастау',
  'results.card.category': 'Санат:',
  'results.card.ikpu': 'ЕНС ТРУ',
  'results.suggest.word': 'Сөз:',
  'results.suggest.wordHint': 'атауы мен сипаттамасында',
  'results.suggest.foot': '↵ — сөз ретінде қосу · санат дәлірек, сөз кеңірек',
  'results.refine': 'Нақтылау',
  'results.refine.empty': 'аймақ · сома · алып тастау',
  'results.refine.region': 'Аймақ',
  'results.refine.addRegion': '+ аймақ',
  'results.refine.sum': 'Лот сомасы, {{currency}}',
  'results.refine.from': 'бастап',
  'results.refine.to': 'дейін',
  'results.refine.any': 'кез келген',
  'results.refine.sumFrom': '{{amount}} бастап',
  'results.refine.sumTo': '{{amount}} дейін',
  'results.refine.exclude': 'Мына сөздер бар лоттарды жібермеу',
  'results.refine.excludePlaceholder': 'сөз…',
  'results.refine.excludeCount': '{{count}} сөзсіз',
  'results.refine.kind': 'Сатып алу түрі',
  'results.refine.customer': 'Тапсырыс беруші',
  'results.refine.customerLabel': 'Тапсырыс берушінің {{tin}}',
  'results.kind.goods': 'Тауарлар',
  'results.kind.works': 'Жұмыстар',
  'results.kind.services': 'Қызметтер',
  'results.count.found': '{{count}} {{word}}',
  'results.count.period': 'бір айда',
  'results.count.week': 'аптада {{count}}',
  'results.count.today': 'бүгін {{count}}',
  'results.count.loading': 'Нәтижелер есептелуде…',
  'results.save': 'Іздеуді сақтау',
  'results.update': 'Іздеуді жаңарту',
  'results.saved': 'Іздеу сақталды',
  'results.save.empty': 'Сөз қосыңыз — іздеуді сақтауға болады',
  'results.save.guest': 'Тегін — тіркелу қажет болады',
  'results.save.note': 'Бір аккаунтқа нәтижелер бойынша бір іздеу — жаңа сақтау оны жаңартады',
  'results.save.error': 'Іздеуді сақтау мүмкін болмады. Қайталап көріңіз',
  'results.changed': 'Өзгертілді: {{list}} — сақтау үшін іздеуді жаңартыңыз',
  'results.updated': 'Жаңартылды: {{list}}',
  'results.created': 'Сақталды. Жаңа нәтижелер туралы хабарландырулар — хабарландыру баптауларында',
  'results.change.region': 'аймақ',
  'results.change.budget': 'сома',
  'results.change.exclude': 'алып тасталатын сөздер',
  'results.change.kind': 'сатып алу түрі',
  'results.change.customer': 'тапсырыс беруші',
  'results.change.text': 'сөздер',
  'results.change.category': 'санаттар',
  'results.change.ikpu': 'коды ЕНС ТРУ',
  'results.change.name': 'атауы',
  'results.wall.line': 'Жеңімпаздардың байланыстары, БСН/ЖСН және сомалары — Pro-да',
  'results.wall.cta': 'Pro рәсімдеу',
  'savedSearches.results.name': 'Нәтижелер',
  'savedSearches.results.hint': 'Ұқсас сатып алу бойынша жеңімпаз анықталғанда хабарлама',
  'savedSearches.results.edit': 'Нәтижелер бетінде өзгерту',
  'shell.search.placeholder': 'Тендерлерді мағынасы бойынша іздеу…',
  'shell.search.ai': 'AI',
  'shell.section.catalog': 'Каталог',
  'shell.section.regions': 'Аймақтар',
  'shell.section.categories': 'Санаттар',
  'shell.showAll': 'Барлығын көрсету ({{count}})',
  'shell.showLess': 'Жию',
  'shell.section.savedSearches': 'Сақталған іздеулер',
  'shell.saved.guestCta': 'Іздеуіңізді сақтаңыз',
  'shell.nav.allTenders': 'Барлық тендерлер',
  'shell.nav.ifiProjects': 'ХҚМ жобалары',
  'shell.nav.supplyRequests': 'Кооперация',
  'shell.nav.favorites': 'Таңдаулылар',
  'favorites.title': 'Таңдаулылар',
  'favorites.subtitle': 'Кейін қайта оралу үшін сақтаған тендерлеріңіз.',
  'favorites.empty.title': 'Мұнда әзірге бос',
  'favorites.empty.desc': 'Тендерді таңдаулыларға қосу үшін карточкадағы ☆ басыңыз.',
  'favorites.empty.cta': 'Каталогқа өту',
  'myTenders.title': 'Менің тендерлерім',
  'myTenders.subtitle': 'Сақталған іздеулеріңізге сай келетін барлық тендерлер, жаңалары жоғарыда',
  'myTenders.chip.all': 'Барлығы',
  'myTenders.showClosed': 'Жабылғандарды көрсету',
  'myTenders.total': 'Барлығы: {{count}}',
  'myTenders.bySearch': 'іздеу бойынша: {{names}}',
  'myTenders.new': 'жаңа',
  'myTenders.newCountAria': 'Менің тендерлерім, жаңа сәйкестіктер: {{count}}',
  'myTenders.empty.title': 'Әзірге ештеңе сәйкес келмеді',
  'myTenders.empty.descOpen':
    'Іздеулеріңіз бойынша ашық тендерлер жоқ. «Жабылғандарды көрсету» опциясын қосыңыз немесе «Хабарландырулар» бетінде іздеуді өзгертіңіз.',
  'myTenders.empty.desc':
    'Іздеулеріңіз бойынша әзірге бірде-бір тендер жоқ. «Хабарландырулар» бетінде шарттарды өзгертіңіз.',
  'shell.nav.alerts': 'Хабарландырулар',
  'shell.nav.menu': 'Мәзір',
  'shell.nav.menu.a11yDesc': 'Сайт бөлімдері, сақталған іздеулер және тіркелгі баптаулары.',
  'shell.nav.openMenu': 'Мәзірді ашу',
  'shell.nav.closeMenu': 'Мәзірді жабу',
  'shell.saved.empty': 'Әзірге сақталған іздеулер жоқ',
  'catalog.saveSearch': 'Іздеуді сақтау',
  'catalog.saveSearchGuest': 'Іздеуді сақтаңыз — хабарландыру алу үшін кіріңіз',
  'saved.close': 'Жабу',
  'savedSearches.title': 'Сақталған іздеулер',
  'savedSearches.edit': 'Өңдеу',
  'savedSearches.summary.from': '{{amount}}-дан',
  'savedSearches.summary.to': '{{amount}}-ға дейін',
  'savedSearches.summary.except': 'қоспағанда: {{terms}}',
  'savedSearches.rate': '≈ күніне {{count}} лот',
  'savedSearches.rate.unknown': 'деректер аз',
  'savedSearches.delete.title': 'Іздеуді жою',
  'savedSearches.delete.confirm':
    '«{{name}}» іздеуін жою керек пе? Ол бойынша хабарландырулар келмей қалады.',
  'savedSearches.instant': 'Бірден жіберу',
  'savedSearches.instant.hint':
    'Әр жаңа лот — жинақты күтпей, жеке хабарлама ретінде. Тек нақты іздеулер үшін (күніне 3 лотқа дейін); сағатына 5 хабарламадан аспайды.',
  'savedSearches.instant.no.broad': 'Тек нақтыланған іздеулер үшін (сөз, ЕНС ТРУ, аймақ, ниша…)',
  'savedSearches.instant.no.rate':
    'Бұл іздеу күніне ≈{{count}} береді — жеке хабарламалар үшін тым көп',
  'savedSearches.instant.no.young': 'Жиілікті бағалау мүмкін болмады — кейінірек қайталап көріңіз',
  'savedSearches.instant.no.plan': 'Pro тарифінде қолжетімді',
  'savedSearches.instant.rejected':
    'Өзгерту мүмкін болмады: іздеу жеке хабарламалар үшін енді жарамайды. Бетті жаңартыңыз.',
  'saved.deleteYes': 'Иә',
  'saved.delete': 'Жою',
  'saved.edit': 'Өзгерту',
  'saved.matches': 'Қазір сәйкес келетін тендерлер: {{n}}',
  'saved.rate': 'бұл сүзгі бойынша аптасына ≈{{n}}',
  'saved.minBudgetLabel': 'Бюджет бастап, {{currency}}',
  'saved.minBudgetPlaceholder': '500 000 000',
  'saved.maxBudgetLabel': 'Бюджет дейін, {{currency}}',
  'saved.maxBudgetPlaceholder': '1 000 000 000',
  'saved.budgetRangeError': '«Дейін» бюджеті «бастап» бюджетінен кіші бола алмайды.',
  'saved.learnedLabel': 'Сіздің 👎 белгілеріңіз бойынша алып тасталды (қайтару үшін басыңыз)',
  'saved.learnedRemove': 'Қайтару',
  'saved.excludeTermsLabel': 'Осы сөздер бар тендерлерді жібермеу',
  'saved.excludeTermsPlaceholder': 'үтірмен бөліңіз',
  'saved.excludeTermsHint': 'Осы сөздердің кез келгені бар тендер хабарландыруға түспейді.',
  'tagInput.remove': '«{{term}}» алып тастау',
  'tagInput.max': 'Ең көбі {{count}}',
  'tagInput.tooLong':
    'Тым ұзын: {{count}} таңба, ең көбі {{max}}. Бір-екі сөзге дейін қысқартыңыз.',
  'saved.matchesNone':
    'Қазір бұл сүзгілер бойынша ашық тендерлер жоқ — сәйкес келетіні пайда болғанша хабарландыру болмайды. Сүзгіні кеңейтіп көріңіз.',
  'saved.nameLabel': 'Атауы',
  'saved.defaultName': 'Менің іздеуім',
  'saved.save': 'Сақтау',
  'saved.cancel': 'Бас тарту',
  'saved.edit.title': 'Іздеуді баптау',
  'saved.edit.a11yDesc': 'Жазылымның атауы, санаттары, ерекшеліктері және ең төменгі бюджеті.',
  'saved.edit.saving': 'Сақталуда…',
  'saved.edit.error': 'Сақтау мүмкін болмады',
  'saved.edit.errorSubject':
    'Кемінде біреуін қалдырыңыз: санат, ЕНС ТРУ, ниша, тапсырыс беруші немесе сөз.',
  'saved.edit.errorInvalid': 'Сақтау мүмкін болмады: өрістерді тексеріп, қайталап көріңіз.',
  'saved.edit.errorTerms':
    'Сөздер тым көп немесе сөз тым ұзын. Артығын алып тастап, қайта сақтаңыз.',
  'saved.saved': 'Сақталды',
  'saved.toast': 'Іздеу сақталды',
  'saved.tender.add': 'Таңдаулыларға',
  'saved.tender.remove': 'Таңдаулылардан алып тастау',
  'saved.limitReached':
    'Тегін тарифте {{n}} іздеуден артық сақтауға болмайды. Шексіз сан үшін Pro рәсімдеңіз.',
  'saved.errorGeneric': 'Іздеуді сақтау мүмкін болмады. Қайталап көріңіз.',
  'saved.emptyCriteria': 'Кемінде бір сүзгі қосыңыз — санат, аймақ, кілт сөз немесе бюджет.',
  'alert.picker.title': 'Қай хабарландыруды баптау керек?',
  'alert.picker.createNew': 'Жаңасын жасау',
  'saved.tuneAlert': 'Хабарландыруларды баптау',
  'saved.deleteAlert': 'Хабарландыруды жою',
  'saved.deleteConfirm': 'Иә, жою',
  'saved.deleteWarning':
    'Бұл іздеу бойынша хабарландырулар келмей қалады. Жаңасын каталогтан жасауға болады.',
  'shell.user.signIn': 'Кіру',
  'shell.user.guest': 'Қонақ',
  'shell.user.notSignedIn': 'Сіз кірмегенсіз',
  'shell.user.freePlan': 'Тегін тариф',
  'shell.user.paidPlan': '{{plan}} тарифі',
  'shell.upgrade.label': 'Pro тарифіне өту',
  'shell.upgrade.desc': 'Тапсырыс берушілердің байланыстарын, құжаттарды және талдауды ашыңыз',
  'telegram.connect.title': 'Хабарландырулар үшін Telegram қосыңыз',
  'telegram.connect.desc':
    'Нишаңыз бойынша жаңа тендерлерді тікелей Telegram-да алыңыз. Төмендегі түймені басып, ботқа сізге жазуға рұқсат беріңіз.',
  'telegram.connect.benefit1': 'Сақталған іздеулер бойынша лезде хабарлама',
  'telegram.connect.benefit2': 'Жеткізушілерге сәйкес келетін тендерлер туралы хабарландыру',
  'telegram.connect.cta': 'Telegram қосу',
  'telegram.bot.cta': 'Telegram арқылы кіру',
  'telegram.bot.waiting': 'Telegram-да Start түймесін басыңыз — кіру өздігінен орындалады',
  'telegram.bot.waitingConnect': 'Telegram-да Start түймесін басыңыз — ол өздігінен қосылады',
  'telegram.bot.waitingDesktop': 'Telegram-ды ашып, Start түймесін басыңыз. Күтудеміз…',
  'telegram.bot.reopen': 'Telegram-ды қайта ашу',
  'telegram.bot.inAppHint':
    'Telegram ашылмады ма? {{app}} ішінде жоғарғы оң жақтағы ⋯ басыңыз → «Браузерде ашу».',
  'telegram.bot.notOpenedHint': 'Telegram ашылмады ма? Сілтемені көшіріп, браузерде ашыңыз.',
  'telegram.bot.copyLink': 'Сілтемені көшіру',
  'telegram.bot.copied': 'Сілтеме көшірілді',
  'telegram.bot.expired': 'Болмады — қайта басыңыз.',
  'telegram.bot.connected': 'Telegram қосылды',
  'telegram.bot.failed': 'Telegram арқылы кіруді дайындау мүмкін болмады. Түймені қайта басыңыз.',
  'telegram.magic.signingIn': 'Кіріп жатырмыз…',
  'telegram.magic.expired':
    'Кіру сілтемесі ескірген немесе пайдаланылған. Telegram арқылы қайта кіріңіз — бұл бір түйме.',
  'telegram.magic.toLogin': 'Кіру',
  'telegram.magic.toSite': 'Сайтқа өту',
  'telegram.magic.checking': 'Сілтемені тексеріп жатырмыз…',
  'telegram.magic.confirmAs': '{{name}} ретінде кіресіз бе?',
  'telegram.magic.confirm': 'Telegram арқылы кіресіз бе?',
  'telegram.magic.confirmHint':
    'Telegram-ботымыздағы сілтеме арқылы кіру. Бұл сіздің Telegram-ыңыз болмаса, «Бұл мен емеспін» түймесін басыңыз.',
  'telegram.magic.signIn': 'Кіру',
  'telegram.magic.notMe': 'Бұл мен емеспін',
  'telegram.magic.linking': 'Telegram қосылып жатыр…',
  'telegram.magic.mismatch':
    'Бұл сілтеме басқа аккаунтқа арналған. Сіз сайтқа өз аккаунтыңызбен кірдіңіз — онда ештеңе өзгерген жоқ.',
  'telegram.connect.mismatch':
    'Бұл Telegram арқылы кіру басқа аккаунттан басталған — ештеңе өзгерген жоқ. Түймені қайта басыңыз.',
  'telegram.connect.error': 'Telegram қосу мүмкін болмады. Қайталап көріңіз.',
  'telegram.connect.taken':
    'Бұл Telegram басқа {{brand}} тіркелгісіне байланысты. Сол тіркелгіге кіріңіз немесе алдымен Telegram-ды одан ажыратыңыз. Telegram тіркелгісін ауыстыру үшін Telegram түймесінің өзінде «Шығу» басыңыз (онда кірген адамның аты көрсетілген) және өз есептік жазбаңызбен кіріңіз.',
  'telegram.connect.hasTeam':
    'Бұл Telegram командада тұрған тіркелгіге байланысты. Мұндай тіркелгіні автоматты түрде біріктіру мүмкін емес — {{brandEmail}} мекенжайына жазыңыз.',
  'telegram.connect.hasAssets':
    'Бұл Telegram жазылымы, төлемдері немесе басқа өз деректері бар тіркелгіге байланысты. Мұндай тіркелгіні автоматты түрде біріктіру мүмкін емес — оған кіріңіз немесе {{brandEmail}} мекенжайына жазыңыз.',
  'telegram.status.connected': 'Telegram қосылған',
  'telegram.status.desc': 'Сақталған іздеулер бойынша хабарландырулар Telegram-ға келеді.',
  'telegram.disconnect.cta': 'Ажырату',
  'telegram.disconnect.pending': 'Ажыратылуда…',
  'telegram.disconnect.confirm':
    'Telegram-ды ажырату керек пе? Қайта қоспайынша хабарландырулар келмейді.',
  'tender.status.active': 'Белсенді',
  'tender.publishedShort': 'жарияланды',
  'tender.status.closing': 'Жақында жабылады',
  'tender.status.closed': 'Аяқталды',
  'tender.ai': 'AI',
  // «₸», not «теңге»: the unit sits beside a compact amount in narrow blocks
  // (budget card, catalogue cards, market data) and the word wrapped under the
  // number on a phone (owner, 2026-10-15). Same in ru.kz.ts.
  'tender.budget.unit': '₸',
  'teaser.srLocked': 'Pro тарифінде қолжетімді',
  'teaser.openPlans': '{{card}} — Pro тарифінде, тарифтерді қарау',
  'teaser.companiesCaption': 'Үлестер, күндер және толық тізім — Pro тарифінде',
  'tender.budget.undisclosed': 'Көрсетілмеген',
  'tender.budget.expedienteTotal': 'Сатып алудың жалпы сомасы',
  'tender.notice.ifb': 'Сауда-саттыққа шақыру',
  'tender.notice.reoi': 'Қызығушылықты білдіру туралы сұрау',
  'tender.notice.gpn': 'Жалпы хабарлама',
  'tender.notice.advance': 'Алдын ала хабарлама',
  'tender.notice.firm': 'Кеңесшілерді іріктеу',
  'tender.notice.consultation': 'Нарықпен алдын ала кеңесу',
  'tender.bidSecurity': 'Өтінімді қамтамасыз ету',
  'tender.deadline.closes': 'Жабылу',
  'tender.deadline.tba': 'Нақтыланады',
  'tender.deadline.announcement': 'Жақында өтінімдер қабылданады',
  'tender.deadline.announcementNote':
    'Бұл анонс: тендер жарияланды және жоспарланды, өтінімдерді қабылдау әлі ашылған жоқ. Жоғалтып алмау үшін оны таңдаулыларға қосыңыз.',
  'tender.consultationNote':
    'Бұл нарықпен алдын ала кеңесу: тапсырыс беруші тендер жарияламас бұрын компаниялардан сұрайды. Жауап беру тегін және ешнәрсеге міндеттемейді — ұсыныстарыңыз болашақ тендердің шарттарына әсер етуі мүмкін.',
  'tender.similar.title': 'Ұқсас тендерлер',
  'tender.closedNoOutcome.title': 'Өтінім қабылдау {{date}} аяқталды',
  'tender.closedNoOutcome.titleNoDate': 'Өтінім қабылдау аяқталды',
  'tender.closedNoOutcome.body': 'Қорытындылар әлі жарияланбаған.',
  'tender.similarLive.title': 'Ұқсас ашық лоттар',
  'tender.similarLive.follow': 'Осындайларды бақылау',
  'list.col.tender': 'Тендер',
  'list.col.budget': 'Бюджет',
  'list.positions.label': 'Позициялар',
  'list.positions.qty': 'Саны',
  'list.positions.more': '… барлығы {{n}}',
  'list.col.noticeType': 'Хабарлама түрі',
  'list.col.deadline': 'Мерзім',
  'list.col.awarded': 'Шешім қабылданған күн',
  'landing.lotCard.contactLabel': 'Тапсырыс берушінің байланысы',
  'landing.lotCard.lockLabel': 'Pro-да',
  'landing.lotCard.activeLabel': 'Белсенді',
  'landing.lotCard.docsLabel': 'ТТ және шарт',
  'landing.lotCard.bidSecurityLabel': 'Қамтамасыз ету',
  'landing.lotCard.daysLeft': '{{n}} {{word}} қалды',
  'landing.nicheSwitcher.emptyLabel':
    'Қазір бұл нишада белсенді лоттар жоқ — санатты толығымен ашыңыз.',
  'landing.illustration.chatLabel': 'Telegram хабарландыруларының мысалы',
  'landing.illustration.rangeAriaLabel':
    '{{label}}: {{min}}-ден {{max}}-ге дейін, бұл позиция — {{pct}}%',
  'search.empty.title': 'Қазір мұндай тендерлер жоқ',
  'search.empty.body':
    'Қазір каталогта сәйкес келетін лот жоқ. Жазылыңыз — жариялау күні поштаңызға немесе Telegram-ға хабарландыру жібереміз.',
  // Сүзгі (санат / ИКПУ / ниша / аймақ / түр / алаң) іздеуді тарылтып, ал бүкіл
  // каталогта осы сөз бойынша лоттар бар кезде ғана көрінеді. `{{word}}` ru.ts
  // үшін (pluralRu) — қазақшада сан есімнен кейін зат есім өзгермейді, сондықтан «лот».
  'search.empty.withoutFilter':
    'Таңдалған сүзгімен «{{q}}» сөзі бойынша ештеңе жоқ. Бүкіл каталогта — {{count}} лот.',
  'search.empty.withoutFilterLink': 'Сүзгісіз көрсету →',
  'niche.hint.applied':
    'Сіз «{{niche}}» нишасын іздеп жатқан сияқтысыз — оның лоттарын нәтижеге қостық.',
  'niche.hint.suggest': 'Сіз «{{niche}}» нишасын іздеп жатқан сияқтысыз.',
  'niche.hint.open': 'Нишаны ашу →',
  'niche.hint.ambiguous': 'Мүмкін, сіз мына нишалардың бірін іздеп жатырсыз:',
  'catalog.lotNumberMatch.one': '№ {{n}} лот табылды',
  'catalog.lotNumberMatch.many': '№ {{n}} нөмірлі лоттар табылды',
  'catalog.cpvCodeMatch': '{{codes}} коды және оның барлық ішкі кодтары бойынша лоттар',
  'catalog.pastLastPage.title': 'Басқа нәтиже жоқ',
  'catalog.pastLastPage.desc': 'Соңғы бет — {{pages}}.',
  'catalog.pastLastPage.first': 'Бірінші бетке',
  'org.hint.intro': '«{{q}}» — ұйымның БСН/ЖСН. Оның профилін ашу:',
  'org.hint.buyer': '{{name}} — тапсырыс беруші',
  'org.hint.supplier': '{{name}} — жеткізуші',
  'list.density.normal': 'Әдепкі',
  'list.density.compact': 'Ықшам',
  'list.empty': 'Ағымдағы сүзгілерге сәйкес тендерлер жоқ.',
  'list.bidPackageReady': 'Өтінім дайын',
  'ifi.badge': 'ХҚМ',
  'supply.badge': 'Кооперация',
  'scope.chips.aria': 'Каталог бөлімі бойынша сүзгі',
  'scope.chips.onlyOther':
    'Бюджеті бар мемлекеттік сатып алуларда сәйкестік жоқ — төменде басқа бөлімдердің лоттары.',
  'scope.chips.didYouMean': 'Мүмкін, сіз мынаны меңзедіңіз:',
  'ifi.page.h1': 'ХҚМ жобалары',
  'ifi.page.intro':
    'Халықаралық институттар қаржыландыратын жобалар бойынша сатып алулар. Тапсырыс беруші — қазақстандық ведомство, қаржыландыру банктік болғандықтан бюджет теңгемен емес, жоба валютасымен жарияланады.',
  'ifi.projects.title': 'Ведомстволар бойынша жобалар',
  'ifi.projects.emptyForSource':
    'Бұл институт орындаушы ведомствоны жарияламайды — бұл кесінді бос.',
  'ifi.projects.subtitle':
    'Халықаралық институттардың жобалары тапсырыс беруші министрліктер мен ведомстволар кесінінде.',
  'ifi.source.aria': 'Институт',
  'ifi.source.all': 'Барлығы',
  'ifi.source.worldbank': 'Дүниежүзілік банк',
  'ifi.source.adb': 'АДБ',
  'ifi.source.aiib': 'AIIB',
  'ifi.source.undp': 'БҰҰДБ',
  'ifi.source.ungm': 'UNGM',
  'ifi.source.isdb': 'ИДБ',
  'ifi.source.ebrd': 'ЕҚДБ',
  'ifi.source.uzrd': 'UzRD',
  'ifi.source.osce': 'ЕҚЫҰ',
  'ifi.source.ariaLabel': '{{label}}, {{count}} тендер',
  'ifi.seo.title': '{{countryPrep}} Дүниежүзілік банк, ADB және БҰҰ агенттіктерінің тендерлері',
  'ifi.seo.description':
    '{{countryPrep}} халықаралық қаржы институттарының жобалары бойынша ашық сатып алулар: Дүниежүзілік банк, АДБ, AIIB, БҰҰ агенттіктері. Мерзімдер, құжаттар, талаптар.',
  'supply.page.h1': 'Кооперация: ұсыныс сұраулары',
  'supply.page.intro':
    'Жарияланған бюджетсіз жеткізу өтінімдері — олар бөлек бөлімге шығарылған және негізгі каталогқа қатыспайды.',
  'supply.seo.title': 'Жарияланған бюджетсіз ұсыныс сұраулары',
  'supply.seo.description': 'Бюджеті көрсетілмеген тауарлар мен қызметтерді жеткізу өтінімдері.',
  'filter.label': 'Сүзгі:',
  'filter.region': 'Аймақ',
  'filter.customer': 'Тапсырыс беруші',
  'filter.category': 'Санат',
  'filter.ikpu.label': 'Немесе тауар коды бойынша',
  'filter.ikpu.allUnder': '{{code}} барлық кодтары',
  'filter.ikpu.searchWords': 'Мұндай код жоқ — «{{q}}» сөздерін лоттардан іздеу',
  'filter.ikpu.noCodeHint':
    'Мұндай сөздері бар код жоқ. Не жеткізетініңізді бір сөзбен жазыңыз, мысалы «жиһаз» немесе «жарнама»',
  'filter.ikpu.countOfParent': '{{total}}-дің {{n}}-і',
  'filter.ikpu.expand': 'Бөлімді жаю',
  'filter.ikpu.collapse': 'Бөлімді жию',
  'filter.more.categories': 'Тағы {{count}} санат көрсету',
  'filter.chip.remove': 'Алып тастау: {{name}}',
  'filter.ikpu.pickedInside': 'Ішінде таңдалған: {{count}}',
  'filter.more.niches': 'Тағы {{count}} ниша көрсету',
  'filter.more.ikpu': 'Тағы кодтар көрсету',
  'filter.status': 'Мәртебе',
  'filter.all': 'Барлығы',
  'filter.selectCategory': 'Санат таңдау',
  'filter.niche': 'Санат немесе тауар',
  'filter.niche.search': 'Іздеу: санат немесе тауар…',
  'filter.multi.selectedCount': 'Таңдалды: {{count}}',
  'niche.section': 'Нишалар',
  'niche.badge': 'ниша',
  'filter.status.active': 'Белсенді',
  'filter.status.closing': 'Жақында жабылады',
  'filter.status.closed': 'Жабық',
  'filter.status.all': 'Барлығы',
  'filter.clear': 'Сүзгілерді тазалау',
  'result.count': '{{count}} {{word}}',
  'result.countAtLeast': '{{count}} {{word}}',
  'result.countOf': '{{total}}-дің {{count}}-і',
  'result.matching': 'ағымдағы сүзгілер бойынша',
  'result.hint.gov':
    'Тек {{countryGen}} ашық мемлекеттік сатып алулары көрсетілген — белсенді және жабылатын. Аяқталған және мерзімі өткендер саналмайды. Каталог автоматты түрде жаңарып тұрады.',
  'result.hint.ifi':
    'Халықаралық институттар (Дүниежүзілік банк, АДБ және т.б.) қаржыландыратын жобалар. Бюджет теңгемен жарияланбайды, сондықтан санатта сомасыз ашық хабарламалар да бар.',
  'result.hint.corporate':
    'Компаниялардың өз сатып алулары (банктер, әуе компаниялары). Тек олардың порталдарындағы ашық хабарландырулар көрсетілген.',
  'catalog.chips.active': '{{count}} белсенді',
  'catalog.chips.closingWeek': '{{count}} жақында жабылады',
  'catalog.chips.newToday': '{{count}} жаңа',
  'catalog.mySelection': 'Сіздің іріктемеңіз: {{count}} {{lots}}',
  'catalog.alertFilter.label': 'Жазылымыңыздың лоттары',
  'catalog.alertFilter.clear': 'Бүкіл каталог',
  'catalog.searchScope.label': '«{{q}}» бойынша нәтижелер — қосулы сүзгілермен',
  'catalog.searchScope.all': 'Бүкіл каталогтан іздеу',
  // Shown on Spain only (`messaging.emailWithoutConfirmation`, AlertWhenNote); key parity.
  'catalog.alertWhen': 'Жаңасы шыққанда {{email}} мекенжайына жазамыз.',
  'catalog.alertWhenRate': 'Жаңасы шыққанда {{email}} мекенжайына жазамыз (аптасына ≈ {{n}}).',
  'catalog.spotlight.title': 'Не жеткізетініңізді таңдаңыз — сәйкес тендерлерді көрсетеміз',
  // Shown on Spain only (`features.alertLanding`, routes/public/catalog.tsx); kept for key parity.
  'catalog.spotlight.noCard': 'Картасыз',
  'catalog.spotlight.openNow': 'Қазір {{count}} ашық',
  'result.updated': 'Жаңартылуда',
  'tgBanner.title': 'Тендерлерді Telegram арқылы алыңыз',
  'tgBanner.desc': 'Сақталған іздеулеріңіз бойынша хабарландырулар',
  'tgBanner.dismiss': 'Жасыру',
  'channelCta.title': 'Ірі тендерлер Telegram-да',
  'channelCta.desc': 'Апта жеңімпаздары мен ең үлкен лоттар — күн сайын',
  'channelCta.button': 'Жазылу',
  'pagination.showing': '{{total}}-дің {{from}}–{{to}} көрсетілді',
  'pagination.prev': 'Артқа',
  'pagination.next': 'Алға',
  'plans.eyebrow': 'Pro тарифтері',
  'plans.title': 'Тапсырыс берушілердің байланыстарын және деректер экспортын ашыңыз',
  'plans.subtitle':
    'Тапсырыс берушілердің байланыстарына қол жеткізу, Excel-ге экспорт, жаңа тендерлер туралы поштаға және Telegram-ға хабарландырулар.',
  'plans.cta': 'Тарифтерді қарау',
  'plans.dismiss': 'Кейінірек',
  'plans.pageTitle': 'Тарифтер',
  'plans.seoTitle': 'Тарифтер мен бағалар — тапсырыс берушілердің байланыстарына қолжетімділік',
  'plans.seoDesc':
    '{{brand}} тарифтері: Pro — {{countryGen}} мемлекеттік сатып алулары бойынша тапсырыс берушілердің байланыстары, тендер құжаттары және деректер экспорты. Сипаттамалар мен талаптарға тегін қолжетімділік.',
  'plans.pageLead':
    'Тендерлерді оқу және талдау тегін. Тариф тапсырыс берушінің байланыстарын, құжаттарды және аналитиканы ашады — қатысу үшін керегінің бәрін.',
  // Shown on Spain only (`FREE_LIMITS_LINE` in routes/plans.tsx); kept for key parity.
  'plans.freeLimits':
    'Тегін және мерзімсіз: әр тендердің ЖИ-түйіндемесі мен талаптары бар каталог және email арқылы хабарламасы бар 3-ке дейін сақталған іздеу. Тапсырыс берушілердің байланыстары мен құжаттама — тек Pro-да.',
  'billing.autoRenew.title': 'Автожаңарту',
  'billing.subscription.title': 'Сіздің жазылымыңыз',
  'billing.autoRenew.card': 'Stripe-тағы карта: {{pan}}',
  'billing.autoRenew.toggle': 'Жазылымды автоматты түрде жаңарту',
  'billing.autoRenew.note':
    'Кезең аяқталатын күні Stripe арқылы растаусыз есептен шығарылады. Кез келген уақытта өшіруге болады.',
  'billing.autoRenew.retention':
    'Ұзарту қосулы тұрғанда қолжетімділік үзілмейді. Өшіру — бір басу: жазылым ұзартылмайды және {{date}} аяқталады.',
  'billing.autoRenew.notePaused':
    'Үзілістен кейін, {{date}} сақталған картадан есептен шығарылады. Жаңартуды кез келген уақытта өшіруге болады — онда үзілістен кейін жазылым қайта жалғаспайды.',
  'billing.autoRenew.remove': 'Картаны жою',
  'billing.autoRenew.changeCard': 'Картаны өзгерту',
  'billing.autoRenew.cancel': 'Жазылымнан бас тарту',
  'billing.autoRenew.nextCharge': 'Келесі есептен шығару: {{date}} · {{amount}}',
  'billing.autoRenew.nextChargeDate': 'Келесі есептен шығару: {{date}}',
  'billing.autoRenew.canceledUntil': 'Жазылым {{date}} дейін белсенді, ол жаңартылмайды.',
  'billing.autoRenew.canceled': 'Автожаңарту өшірілген.',
  'billing.pause.running': '{{until}} дейін үзіліс: қолжетімділік жабық, төлем {{until}}',
  'billing.pause.scheduled':
    '{{from}} бастап {{until}} дейін үзіліс: қолжетімділік жабылады, төлем {{until}}',
  'billing.pause.resume': 'Қазір жалғастыру',
  'billing.pause.resumeNote':
    'Әдеттегі тариф бойынша бір-екі сағат ішінде төлем алынады, қолжетімділік бірден ашылады.',
  'billing.pause.cancel': 'Үзілісті болдырмау',
  'billing.autoRenew.declined':
    'Төлемді есептен шығару мүмкін болмады — автожаңартуды жалғастыру үшін картаны жаңартыңыз.',
  'billing.autoRenew.updateCard': 'Картаны жаңарту',
  // Жазылымнан бас тарту себебі (2026-09-21).
  'churn.title.autoRenew': 'Автожаңартуды өшіресіз бе?',
  'churn.title.card': 'Картаны жоясыз ба?',
  'churn.why': 'Неге?',
  'churn.value': 'Іздеулеріңіз бойынша бір айда {{n}} {{word}} келді',
  'churn.confirm.autoRenew': 'Жаңартуды өшіру',
  'churn.confirm.card': 'Картаны жою',
  'churn.pause': '1 айға үзіліс — кейін ескі бағамен жалғасады',
  'churn.pauseNote': 'Қолжетімділік {{from}} жабылады, {{to}} дейін төлем алынбайды.',
  'churn.pauseNoteNoDate': 'Қолжетімділік бір айға жабылады, төлем алынбайды.',
  'churn.pickReason': 'Себебін таңдаңыз',
  'churn.detailsLabel': 'Толығырақ (міндетті емес)',
  'churn.detailsRequired': 'Толығырақ жазыңыз',
  'churn.retain.noRelevantTenders':
    'Бізге Telegram арқылы жазыңыз — іздеуді 10 минутта сізге бейімдеп береміз',
  'churn.retain.poorAlerts': 'Іздеуді тарылтамыз — Telegram арқылы жазыңыз',
  'churn.retain.changingCard':
    'Картаны жоюдың қажеті жоқ — жаңасын байланыстырыңыз, ескісі ауыстырылады',
  'churn.reason.changingCard': 'Картаны ауыстырамын',
  'churn.reason.noCardStorage': 'Картаны сақтағым келмейді',
  'churn.reason.stopRenewing': 'Жаңартпаймын',
  'churn.reason.noRelevantTenders': 'Қолайлы тендер жоқ',
  'churn.reason.didNotWin': 'Жеңе алмадым',
  'churn.reason.noTime': 'Уақыт жоқ',
  'churn.reason.foundBetter': 'Басқа сервис таптым',
  'churn.reason.tooExpensive': 'Қымбат',
  'churn.reason.oneOffNeed': 'Бір рет керек болды',
  'churn.reason.poorAlerts': 'Пайдалы хабарландыру аз',
  'churn.reason.hardToUse': 'Түсіну қиын',
  'churn.reason.paymentIssue': 'Төлем мәселесі',
  'churn.reason.other': 'Басқа',
  'billing.history.title': 'Төлемдер тарихы',
  'billing.history.showAll': 'Барлығын көрсету ({{count}})',
  'billing.history.fiscalReceipt': 'Түбіртек',
  'billing.history.status.completed': 'Төленді',
  'billing.history.status.pending': 'Төлемді күтуде',
  'billing.history.status.preparing': 'Өңделуде',
  'billing.history.status.cancelled': 'Бас тартылды',
  'billing.autoRenew.addPrompt':
    'Жазылым әр кезеңде қолмен төлеусіз автоматты жаңарылуы үшін картаны байланыстырыңыз.',
  'billing.autoRenew.addCard': 'Картаны байланыстыру',
  'billing.card.title': 'Картаны байланыстыру',
  'billing.card.titleSubscribe': 'Жазылымды рәсімдеу',
  'billing.card.subtitle': 'Карта деректерін Stripe өңдейді. Біз картаны сақтамаймыз.',
  'billing.card.subscribeSubtitle': 'Картаны біз сақтамаймыз — деректерді Stripe өңдейді.',
  'billing.card.securedBy': 'Төлем қорғалған',
  'billing.card.planLabel': 'Тариф',
  'billing.card.chargeNowLabel': 'Қазір есептен шығарылады',
  'billing.card.policyPrefix': 'Жазылым рәсімдей отырып, сіз қабылдайсыз',
  'billing.card.policyOffer': 'офертаны',
  'billing.card.renewLabel': 'Автожаңарту',
  'billing.card.thenMonthly': 'айына {{amount}}',
  'billing.card.thenYearly': 'жылына {{amount}}',
  'billing.card.upsellYear': 'Жылдыққа өту — {{months}} ай тегін',
  'billing.card.pitchCategory':
    'Санатыңыздың {{count}} тендері осы аптада жабылады — байланыстар ішінде',
  'billing.card.pitchMarket': 'Қазір {{sum}} {{currency}} сомасына {{count}} тендер ашық',
  'billing.card.payAmount': '{{amount}} төлеу',
  'billing.card.nextChargeOn': 'Келесі есептен шығару — {{date}}.',
  'billing.card.remindTelegram': 'Telegram-да еске саламыз.',
  'billing.card.remindEmail': 'Поштаға еске саламыз.',
  'billing.card.cancelHow': 'Өшіру — «Тарифтер» бөлімінде екі басу.',
  'billing.card.cancelAnytime':
    'Автожаңартудан кез келген уақытта жеке кабинетте бас тартуға болады.',
  'billing.card.periodMonthly': 'айға',
  'billing.card.periodAnnual': 'жылға',
  'billing.card.otpRecap': '{{card}} картасынан {{amount}} төлем',
  'billing.card.receiptPayme': 'Төлем түбіртегі поштаңызға келеді',
  'billing.card.receiptOcto': 'Төлем түбіртегі төлемдер тарихында қолжетімді болады',
  'billing.card.timelineToday': 'Бүгін',
  'billing.card.timelineTodayText': '{{amount}}, қолжетімділік бірден ашылады',
  'billing.card.timelineRemind': 'жаңарту туралы еске салу хаты',
  'billing.card.timelineRemindTelegram': 'Telegram-да еске саламыз',
  'billing.card.timelineRemindEmail': 'поштамен еске саламыз',
  'billing.card.timelineRenew': 'жаңарту',
  'billing.card.timelineToggle': 'Төлем және жаңарту',
  'billing.card.renewLine': 'Ұзарту {{date}}.',
  'billing.card.nextHint': 'Әрі қарай банк растау кодын сұрауы мүмкін.',
  'billing.card.smsFromPayme': 'Растау коды — банкіңізден, карта нөмірін біз көрмейміз',
  'billing.card.nicheOpen': 'Іздеулеріңіз бойынша қазір {{count}} ашық лот',
  'billing.card.nicheDirection': 'Іздеулеріңіз бойынша айына {{count}} жаңа лот шығады',
  'billing.card.nicheDaily': 'Күн сайын {{count}} жаңа лот шығады',
  'billing.card.securedByPay': 'Төлем қорғалған — Stripe өңдейді',
  'billing.card.securedByOcto': 'Төлем қорғалған — Stripe өңдейді',
  'billing.card.refund7': '7 күн — қаражатты қайтару кепілдігі',
  'billing.card.securedByClick': 'Төлем қорғалған — Stripe өңдейді',
  'billing.card.securedByPayClick': 'Төлем қорғалған — Stripe өңдейді',
  'billing.card.supportTg': 'Telegram-дағы қолдау',
  'billing.card.offerLink': 'Оферта',
  'billing.card.privacyLink': 'Құпиялылық',
  'billing.card.policyAnd': 'және',
  'billing.card.policyPrivacy': 'құпиялылық саясатын',
  'billing.card.policySuffix': '.',
  'plans.subscribeWithCard': '{{name}} тарифіне жазылу',
  'plans.payOnceLead': 'Төлем Stripe тарапында · бізде картаны енгізудің қажеті жоқ',
  'plans.payOnceLeadVia': 'Төлем {{gateway}} тарапында · бізде картаны енгізудің қажеті жоқ',
  'plans.payOnceBtn': 'Бір реттік төлеу',
  'plans.cardOnlyCta': 'Картамен төлеу',
  'plans.checkoutLinkFailed': 'Төлем бетін ашу мүмкін болмады. «Төлеу» түймесін қайта басыңыз.',
  'plans.stripe.renews':
    'Жазылым ай сайын ұзартылады. Ұзартуды кез келген уақытта осы жерде, тарифтер бетінде өшіруге болады.',
  'plans.stripe.alreadySubscribed':
    'Сізде ұзартылатын жазылым бар. Тарифті ауыстыру үшін төменде автоұзартуды өшіріңіз — төленген кезең сақталады — және жаңасын рәсімдеңіз.',
  'plans.stripe.payee': 'Карта арқылы төлемдерді Stripe арқылы {{name}} (АҚШ) қабылдайды',
  'billing.stripe.payMonthly': '{{amount}} / ай төлеу',
  'billing.stripe.loading': 'Төлем формасы дайындалуда…',
  'billing.stripe.loadFailed':
    'Төлем формасын ашу мүмкін болмады. Терезені жауып, қайталап көріңіз.',
  'billing.stripe.errorFunds':
    'Картада қаражат жеткіліксіз. Оны толтырыңыз немесе басқа картаны енгізіңіз.',
  'billing.stripe.errorExpired': 'Картаның қолданылу мерзімі өтіп кеткен. Басқа картаны енгізіңіз.',
  'billing.stripe.errorCard': 'Карта нөмірін, қолданылу мерзімін және CVC кодын тексеріңіз.',
  'billing.stripe.error3ds':
    'Банк төлемді растамады. Қайталап көріңіз немесе басқа картаны енгізіңіз.',
  'billing.stripe.errorDeclined':
    'Банк төлемді қабылдамады. Басқа картаны қолданып көріңіз немесе банкке хабарласыңыз.',
  // Chile: under a refusal in the card sheet, before the support address.
  'billing.stripe.declineHelp': 'Төлем өтпей ме? Бізге жазыңыз, көмектесеміз:',
  'billing.stripe.errorGeneric': 'Төлем өтпеді. Қайталап көріңіз.',
  'billing.stripe.priceSuffix': '/ ай',
  'billing.stripe.billingTitle': 'Шот деректері',
  'billing.stripe.billingHint':
    'Міндетті емес. Қоссаңыз, олар шоттарда көрсетіледі. Оларды кейін де, параметрлерде қосуға болады.',
  // Owner, 2026-10-22: the card form is price + card + pay like KazTender's; the
  // invoice details are one collapsed link, and the IVA sentence sits behind «more».
  'billing.stripe.invoiceToggle': 'Шот деректері (міндетті емес)',
  'billing.stripe.termsHeadline': 'ҚҚС кірмейді · 14 күн қайтару кепілдігі',
  'billing.stripe.taxMore': 'ҚҚС туралы толығырақ',
  // After the payment: /billing/return and settings (`InvoiceDetailsPrompt`).
  'billing.invoice.ask':
    'Шотты салық нөміріңізбен және мекенжайыңызбен алу үшін оларды осы жерде қосыңыз',
  'billing.invoice.hint': 'Олар осы сәттен бастап берілетін шоттарда көрсетіледі.',
  'billing.invoice.save': 'Деректерді сақтау',
  'billing.invoice.saved':
    'Сақталды. Деректер келесі шоттарда болады. Осы төлемнің шотында керек болса, {{brandEmail}} мекенжайына жазыңыз.',
  'billing.invoice.failed': 'Деректерді сақтау мүмкін болмады. Қайталап көріңіз.',
  'billing.invoice.onFile': 'Шот деректері сақталған: {{details}}',
  'billing.stripe.fieldName': 'Компания атауы немесе аты-жөні',
  'billing.stripe.fieldTaxId': 'Салық нөмірі',
  'billing.stripe.fieldLine1': 'Мекенжай',
  'billing.stripe.fieldLine1Placeholder': 'Көше, үй, пәтер',
  'billing.stripe.fieldPostalCode': 'Пошта индексі',
  'billing.stripe.fieldCity': 'Қала',
  'billing.stripe.fieldState': 'Облыс',
  'billing.stripe.fieldCountry': 'Ел',
  'billing.stripe.errorTaxId': 'Салық нөмірінде қате бар.',
  'billing.stripe.errorPostalCode': 'Пошта индексін тексеріңіз.',
  'billing.stripe.errorBilling': 'Шот деректерін тексеріңіз.',
  'plans.vat.excluded': '+ ҚҚС',
  'plans.vat.included': '(ҚҚС қосылған)',
  'plans.vat.notCharged': '· ҚҚС кірмейді',
  'plans.vat.why':
    'Баға ҚҚС-сыз. Қызметті AI CRM Inc. (АҚШ) көрсетеді, компания ЕО-да тіркелмеген: компаниялар мен ЖК ҚҚС-ты өздері есептейді.',
  'plans.cardOnlyPrice': '{{amount}} / ай',
  'plans.cardOnlyRenews':
    'Ай сайын автоматты түрде ұзартылады. Жеке кабинетте кез келген уақытта өшіруге болады.',
  'plans.onceSheetTitle': '{{name}} тарифі — 1 ай',
  'plans.onceSheetPick': 'Төлеу үшін қосымшаны таңдаңыз',
  'plans.oncePayNow': '{{amount}} төлеу',
  'plans.oncePreparing': 'Төлемді дайындап жатырмыз…',
  'plans.onceExternalHint': 'Төлем телефон браузерінде ашылады',
  'plans.handoffStuck': 'Ашылмады ма? Сілтемені телефон браузерінде ашыңыз',
  'plans.handoffCopy': 'Сілтемені көшіру',
  'plans.handoffCopied': 'Көшірілді',
  'plans.onceSheetClose': 'Жабу',
  'plans.onceTimelineTitle': 'Төлем және қолжетімділік',
  'plans.onceAccessLine': '{{days}} күнге қолжетімділік, {{date}} дейін. Автоұзартусыз.',
  'plans.onceTimelineSub': '{{days}} күнге қолжетімділік',
  'plans.onceTimelineToday': 'Бүгін',
  'plans.onceTimelineTodayText': '{{amount}}, қолжетімділік бірден ашылады',
  'plans.onceTimelineEnd': 'қолжетімділік аяқталады',
  'plans.social': '{{country}} Республикасының жеткізушілеріне арналған тендерлер мен сатып алулар',
  // The line with the live registrations count. Required by key parity with
  // ru.ts; NOT shown on Kazakhstan today — it appears only from 500 accounts up
  // (`socialProofCount`), and there are 34. «кемінде {{count}}» («at least»)
  // rather than «{{count}}-нан астам»: the ablative ending changes with the
  // last digit, and the number is filled in by code.
  'plans.socialLive': '{{country}} Республикасының кемінде {{count}} жеткізушісі бізбен бірге',
  'plans.openNow': 'Қазір {{count}} ашық тендер',
  'plans.group.search': 'Іздеу',
  'plans.group.contacts': 'Байланыс',
  'plans.group.analysis': 'Талдау',
  'plans.business.plus': 'Pro-дағының бәрі, оған қоса:',
  'plans.octo.title': 'Жазылымды рәсімдеу',
  'plans.octo.tabOcto': 'Stripe',
  'plans.octo.tabPayme': 'Банк картасы',
  'plans.octo.continue': 'Stripe арқылы жалғастыру',
  'plans.octo.redirectNote': 'Карта деректері Stripe-тың қорғалған бетінде енгізіледі',
  'plans.octo.error': 'Төлемді бастау мүмкін болмады. Қайталап көріңіз.',
  'plans.accessUntil':
    'Деректер талдауына қолжетімділік төлемнен кейін {{date}} дейін белсенді · кез келген уақытта бас тартуға болады',
  'plans.cantPay': 'Төлей алмай тұрсыз ба?',
  'plans.trust.secureTitle': 'Қауіпсіз төлем',
  'plans.trust.secureText': 'Картаны Stripe өңдейді — біз оның нөмірін көрмейміз және сақтамаймыз',
  'plans.trust.noSurpriseTitle': 'Жасырын есептен шығарусыз',
  'plans.trust.noSurpriseText':
    'Ай сайынғы жазылым: әр есептен шығару алдында еске саламыз, ұзартуды кез келген уақытта өшіруге болады',
  'plans.trust.refundTitle': 'Қайтару кепілдігі',
  'plans.trust.refundText':
    'Алғашқы төлем ұнамады ма? 7 күн ішінде бізге жазыңыз — ақшаны қайтарамыз',
  'plans.trust.receiptTitle': 'Төлем түбіртегі',
  'plans.trust.receiptText': 'Төлемнен кейін түбіртек поштаңызға келеді',
  'billing.card.smsFrom':
    'Растау коды банкіңізден ({{brand}}-тен емес) картаға байланысты нөмірге келеді.',
  // OTP қадамында әрқашан көрінеді — екі SMS келгенде қай код
  // тексерілетіні белгісіз (23.09.2026 байқалған).
  'billing.card.otpUseLast': 'Соңғы SMS-тегі кодты енгізіңіз',
  'billing.card.resendIn': 'Кодты {{time}} кейін қайта жіберуге болады',
  'billing.card.resend': 'Кодты қайта жіберу',
  'billing.card.newCodeIn': 'Жаңа код {{time}} кейін',
  'billing.card.errorResend': 'Кодты жіберу мүмкін болмады. Қайталап көріңіз.',
  'billing.card.otpSubtitle': 'Банктен келген растау кодын енгізіңіз.',
  'billing.card.otpTitle': 'Төлемді растаңыз',
  'billing.card.otpBack': 'Артқа',
  'billing.card.otpDigit': '{{n}}-сан',
  'billing.card.stepCard': 'Карта',
  'billing.card.stepCode': 'SMS коды',
  'billing.card.stepAccess': 'Қолжетімділік ашылды',
  'billing.card.smsSentTo': 'Банк растау кодын {{phone}} нөміріне жіберді.',
  'billing.card.smsSentGeneric': 'Банк растау кодын картаға байланысты нөмірге жіберді.',
  'billing.card.otpChargeLine': '{{scheme}} {{card}} · {{amount}} есептен шығарылады',
  'billing.card.confirmPay': 'Төлемді растау',
  'billing.card.otpFraud': 'Кодты ешкімге айтпаңыз — {{brand}} қызметкерлері оны сұрамайды.',
  'billing.card.number': 'Карта нөмірі',
  'billing.card.expire': 'Мерзімі',
  'billing.card.expirePlaceholder': 'ММ/ГГ',
  'billing.card.otp': 'SMS коды',
  'billing.card.next': 'Келесі',
  'billing.card.confirm': 'Растау',
  'billing.card.errorCard': 'Картаны байланыстыру мүмкін болмады. Нөмірі мен мерзімін тексеріңіз.',
  'billing.card.errorCardNotAccepted':
    'Карта нөмірі мен мерзімін тексеріңіз. Бәрі дұрыс болса — бір минуттан кейін қайталап көріңіз немесе басқа картаны енгізіңіз.',
  'billing.card.errorPaymeUnavailable':
    'Төлем қызметі уақытша қолжетімсіз. Кейінірек қайталап көріңіз.',
  'billing.card.errorTinRequired':
    'Бұл тариф үшін компанияның БСН/ЖСН қажет. Оны баптауларда көрсетіп, төлемді қайталаңыз — растау коды мұнда рөл атқармайды.',
  'billing.card.errorOtp': 'Код қате. Қайталап көріңіз.',
  'billing.card.errorChargeFailed':
    'Банк осы картадан есептен шығаруды қабылдамады. Басқа картаны қолданып көріңіз.',
  'billing.card.errorInsufficientFunds':
    'Картада қаражат жеткіліксіз. Картаны толтырыңыз немесе басқасын қолданыңыз.',
  'billing.card.errorCardNotFound': 'Мұндай нөмірлі карта табылмады. Нөмірді тексеріңіз.',
  'billing.card.errorCorporateCard':
    'Бұл корпоративтік карта қабылданбайды. Басқа картаны қолданыңыз.',
  'billing.card.errorCardBlocked': 'Картаны банк бұғаттаған. Басқа картаны қолданыңыз.',
  'billing.card.errorCardExpired': 'Картаның мерзімі өткен. Басқа картаны қолданыңыз.',
  'billing.card.errorSmsNotEnabled':
    'Картада SMS-хабарландыру қосылмаған. Оны банкте қосыңыз немесе басқа картаны қолданыңыз.',
  'billing.card.errorWrongExpiry': 'Жарамдылық мерзімі қате. Айы мен жылын тексеріңіз.',
  'billing.card.errorWrongNumber': 'Карта нөмірі қате. Нөмірді тексеріңіз.',
  'billing.card.errorCardNotServed': 'Бұл карта онлайн төлемге жарамайды. Басқасын қолданыңыз.',
  'billing.card.errorLimitExceeded': 'Картаның айлық лимиті таусылды. Басқа картаны қолданыңыз.',
  'billing.card.errorCurrency': 'Карта валютасы сәйкес емес. Басқа картаны қолданып көріңіз.',
  'billing.card.errorProcessingUnavailable':
    'Банк уақытша қолжетімсіз. Бірнеше минуттан кейін қайталаңыз.',
  'billing.card.errorOtpExpired': 'Кодтың мерзімі өтті. Жаңасын сұраңыз.',
  'billing.card.errorOtpAttempts': 'Әрекеттер таусылды. Жаңа код сұраңыз.',
  'billing.card.errorEmpty': 'Карта нөмірін енгізіңіз',
  'billing.card.errorExpireEmpty': 'Мерзімін көрсетіңіз',
  'billing.card.errorIncomplete': 'Карта нөмірінің 16 санын енгізіңіз',
  'billing.card.errorInvalidNumber': 'Карта нөмірі қате енгізілді',
  'billing.card.errorUnsupported':
    'Мұндай карта қолдау таппайды. Нөмірін тексеріңіз: Visa және Mastercard қабылданады.',
  'billing.card.errorPaymeBrandUnsupported':
    'Бұл карта автотөлемге жарамайды. Бір рет төлеңіз — тарифтегі «Бір реттік төлеу» түймесі.',
  'billing.card.errorUnsupportedOcto':
    'Бұл карта қолдау таппайды. Visa немесе Mastercard картасын қолданыңыз.',
  'billing.card.payViaOcto': 'Басқа картамен төлеу',
  'billing.card.foreignBrandHint': 'Visa және Mastercard карталары қабылданады.',
  'billing.card.corporateOcto': 'Корпоративтік карталар қабылданбайды.',
  'billing.card.errorExpired': 'Мерзімі өтіп кеткен',
  'billing.card.errorExpireInvalid': 'Мерзімі қате',
  'plans.perYear': '/ жыл',
  'plans.periodMonth': 'ай',
  'plans.periodYear': 'жыл',
  'plans.perMonth': '/ ай',
  'plans.from': 'бастап',
  'plans.tiersCount': 'таңдауға {{count}} {{word}}',
  'plans.bannerYear': 'Жыл — 6 ай бағасына',
  'plans.bannerPair': 'Pro және Бизнес · ай сайын',
  'plans.name.pro': 'Pro',
  'plans.name.business': 'Бизнес',
  'plans.name.ip': 'ЖК',
  'plans.name.free': 'Бастау',
  'plans.som': '{{currency}}',
  'plans.feature.opens': 'айына {{count}} байланыс ашу',
  'plans.feature.categoryLimit': '{{count}} санатқа дейін',
  'plans.feature.categoryLimitUnlimited': 'ЕНС ТРУ санаттары шексіз',
  'plans.feature.categoryNiche': '1 ниша + поштаға немесе Telegram-ға хабарламалар',
  'plans.feature.contactsNiche': 'Мемлекеттік сатып алулар каталогы',
  'plans.feature.allTenders': '{{country}} Республикасының барлық тендерлері',
  // Kazakhstan-only catalogue: no Uzbek companies (Beeline, Uzum, Ucell were here).
  // The only corporate platform with lots is mitwork.kz; IFI lots on KZ come from
  // UN agencies, ADB and EBRD (no World Bank lots on 2026-10-15) — see ru.kz.ts.
  'plans.feature.privateTenders': 'Mitwork алаңындағы компаниялардың корпоративтік сатып алулары',
  'plans.feature.ifi': 'ХҚМ тендерлері: БҰҰ, ADB, ЕҚДБ',
  'plans.feature.contactsMetered': 'айына {{count}} тапсырыс беруші {{word}}',
  'plans.feature.budgetCeiling': 'Бюджеті {{amount}} млн {{currency}} дейінгі тендерлер',
  'plans.feature.contactsAll': 'Тапсырыс берушілердің барлық байланыстары — шексіз',
  'plans.feature.winnerContacts': 'Өткен тендер жеңімпаздарының байланыстары — телефон және пошта',
  'plans.feature.documents': 'Тендер құжаттары (ТТ, спецификациялар)',
  'plans.feature.procedure': 'Рәсімді өткізу тәртібі',
  'plans.feature.aiSummary': 'ТТ талдауы мен талаптары — тегін',
  'plans.feature.aiSummaryFull': 'ТТ толық талдауы мен талаптары (KZ/RU)',
  'plans.feature.savedSearchOne':
    '3 сақталған іздеуге дейін + поштаға немесе Telegram-ға хабарламалар',
  'plans.feature.savedSearchAll': 'Сақталған іздеулер шексіз + хабарламалар',
  'plans.feature.supplierProfile': 'Жеңген тендерлеріңіз бойынша профиль — баптаусыз хабарламалар',
  'plans.feature.telegramBot': 'Telegram-бот: іздеу, ЖИ-жауаптар, жинақтар, жазылымдарды басқару',
  'plans.feature.export': 'Excel-ге экспорттау',
  'plans.feature.buyerAnalytics':
    'Тапсырыс берушілерді талдау: кіммен жұмыс істейді, сатып алу шоғырлануы және жылдық көлемі',
  'plans.feature.analytics': 'Әр тендер бойынша жеңімпаз бағалары мен базалық мөлшерлемелер',
  // Shown on Spain only (`features.marketFirstPitch`, routes/plans.tsx); kept for key parity.
  'plans.feature.sourceAlso':
    'Тапсырыс берушінің байланысы, құжаттама және ресми хабарландыру бір басумен',
  // Like ru: «уведомления», not «in Telegram» — on KZ the award digest goes by
  // e-mail or Telegram, whichever the user has (2026-10-15).
  'plans.feature.orgWatch':
    '50 тапсырыс беруші мен бәсекелестерді бақылау — жаңа келісімшарттар туралы хабарламалар',
  'plans.feature.prioritySupport': 'Басым қолдау',
  'plans.business.seats': 'Командадағы орындар: {{count}} — сіз және қызметкерлеріңіз',
  'plans.business.seatsGeneric': 'Команда үшін бірнеше орын',
  'plans.business.telegram': 'Әр қызметкердің өз Telegram-боты және өз хабарландырулары бар',
  'baseRates.title': 'Нарық деректері',
  'baseRates.hint':
    'Осы санаттағы және жақын көлемдегі (осы лоттың бюджетінің 0,3-тен 3 еселенгеніне дейін) аяқталған сатып алулар бойынша бастапқы бағадан жеңілдіктің медианасы, қатысушылар саны және жеңімпаз бағасының диапазоны. Бәсекелестік пен әділ бағаны бағалауға көмектеседі.',
  'baseRates.competition': 'Қатысушылар медианасы',
  'baseRates.discount': 'Медианалық жеңілдік',
  'baseRates.discountCaption': 'Жеңімпаздар бастапқы бағадан қаншалықты төмендеді',
  'baseRates.degenerate':
    'Сатып алулардың {{pct}}%-ы бірдей мәнмен — бұл алаң ережесі, нарықтық көрсеткіш емес',
  'baseRates.priceBand': 'Жеңімпаз бағасының диапазоны',
  'baseRates.priceMedian': 'Жеңімпаз бағасының медианасы',
  'baseRates.priceBasisBanded': 'Дәл сондай көлемдегі салыстырмалы сатып алулар бойынша медиана',
  'baseRates.priceBasisSection': 'Бүкіл санат бойынша медиана — лот көлемін есепке алмай',
  'baseRates.basisBanded':
    '{{n}} салыстырмалы сатып алу бойынша: жеңімпаз бағасы {{min}} – {{max}}, {{from}} – {{to}}',
  'baseRates.basisBandedNoDates':
    '{{n}} салыстырмалы сатып алу бойынша: жеңімпаз бағасы {{min}} – {{max}}',
  'baseRates.basisSection': 'Санаттың {{n}} сатып алуы бойынша, {{from}} – {{to}}',
  'baseRates.basisSectionNoDates': 'Санаттың {{n}} сатып алуы бойынша',
  'baseRates.teaserBasis': '{{period}} ішіндегі {{n}} салыстырмалы сатып алу бойынша',
  'baseRates.teaserBasisNoDates': '{{n}} салыстырмалы сатып алу бойынша',
  'baseRates.teaserMonths.one': '{{n}} ай',
  'baseRates.teaserMonths.few': '{{n}} ай',
  'baseRates.teaserMonths.many': '{{n}} ай',
  'baseRates.sizeBlind':
    'Лотта бюджет көрсетілмеген, сондықтан салыстыру бүкіл санат бойынша жүреді және лот көлемін ескермейді.',
  'baseRates.positionBelow':
    'Лот бюджеті мұндай сатып алулардағы әдеттегі жеңімпаз бағасынан төмен',
  'baseRates.positionInside': 'Лот бюджеті жеңімпаздардың әдеттегі баға диапазонының ішінде',
  'baseRates.positionAbove':
    'Лот бюджеті мұндай сатып алулардағы әдеттегі жеңімпаз бағасынан жоғары',
  'baseRates.insufficient': 'Бұл санат бойынша деректер әзірге жеткіліксіз',
  'baseRates.locked': 'Аналитика Pro тарифінде қолжетімді',
  'baseRates.lockedCta': 'Тарифтерді қарау',
  // Shown on Spain only (`features.freeBidderMedian`, WinDiscountLine); kept for key parity.
  'baseRates.winLine.question': 'Қанша бағамен ұтады?',
  'baseRates.winLine.basis': '{{n}} ұқсас лот бойынша медианалық жеңілдік:',
  'market.title': '{{countryGen}} мемлекеттік сатып алулары нарығы',
  'market.subtitle':
    'Сандардағы ашық тендерлер мен сатып алу қорытындылары: бюджеттер, аймақтар, секторлар және динамика.',
  'market.summary':
    'Қазір {{countryGen}} {{budget}} сомасына {{active}} мемлекеттік тендер ашық; соңғы аптада {{newWeek}} қосылды. Төменде — бюджеттің аймақтар мен секторлар бойынша бөлінуі және аяқталған сатып алулардың қорытындылары.',
  'market.seo.title': '{{countryGen}} мемлекеттік сатып алулары нарығы — статистика және аналитика',
  'market.seo.description':
    '{{countryGen}} мемлекеттік сатып алулары нарығының аналитикасы: қанша тендер ашық, аймақтар мен секторлар бойынша бюджеттер, сатып алу қорытындылары бойынша көлем мен бәсекелестік.',
  'market.som': '{{currency}}',
  'market.count': '{{count}} сатып алу',
  'market.generatedAt': '{{date}} мәліметтері',
  'market.kpi.active': 'Белсенді тендерлер',
  'market.kpi.budget': 'Нарықтағы бюджет',
  'market.kpi.newWeek': 'Аптаға жаңалары',
  'market.kpi.closingSoon': 'Жақында жабылады',
  'market.kpi.awardedCount': 'Жылдағы сатып алулар',
  'market.kpi.awardedVolume': 'Жылдағы көлем',
  'market.direct':
    'Тікелей шарттар бойынша (саудасыз) сол кезеңде: {{count}}, {{volume}}. Олар жоғарыдағы сандарға кірмейді.',
  'market.byRegion': 'Аймақтар бойынша бюджет',
  'market.byCategory': 'Санаттар бойынша бюджет',
  'market.newPerWeek': 'Апта сайынғы жаңа тендерлер',
  'market.awardedByYear': 'Жылдар бойынша сатып алулар',
  'chart.noData': 'деректер жоқ',
  'market.competition': 'Секторлар бойынша қатысушылар медианасы',
  'market.discount': 'Секторлар бойынша медианалық жеңілдік',
  'market.range.from': 'Күні бастап',
  'market.range.to': 'Күні дейін',
  'market.range.reset': 'Кезеңді тазалау',
  'nav.market': 'Нарық',
  'prices.title': 'Тауар бағалары',
  'prices.subtitle': 'Мемлекет тауар санаты үшін орта есеппен қанша төлейді',
  'prices.seoTitle': '{{name}} — мемлекеттік сатып алу бағалары',
  'prices.seoDesc.bandDated':
    '«{{name}}» келісімшартының медианалық бағасы — {{median}} {{currency}}, диапазон {{p25}}–{{p75}}. {{countryGen}} {{from}}–{{to}} аралығындағы {{n}} аяқталған мемлекеттік сатып алу бойынша.',
  'prices.seoDesc.band':
    '«{{name}}» келісімшартының медианалық бағасы — {{median}} {{currency}}, диапазон {{p25}}–{{p75}}. {{countryGen}} {{n}} аяқталған мемлекеттік сатып алуы бойынша.',
  'prices.seoDesc.sample':
    '{{countryPrep}} «{{name}}» аяқталған мемлекеттік сатып алуларының статистикасы: жеңімпаз бағалары бар {{n}} сатып алу үлгісі.',
  'prices.seoDesc.empty':
    'Мемлекет «{{name}}» үшін қанша төлейді — {{countryGen}} аяқталған мемлекеттік сатып алулары бойынша деректер.',
  'prices.search': 'Тауар немесе код бойынша іздеу',
  'prices.count': '{{count}} сатып алу',
  'prices.empty': 'Әзірге сатып алу тарихы жеткілікті санаттар жоқ.',
  'prices.back': '← Тауарларға',
  'prices.locked': 'Баға аналитикасы Pro тарифінде қолжетімді.',
  'prices.locked.cta': 'Pro ашу',
  'prices.insufficient': 'Бұл санат бойынша статистика үшін аяқталған сатып алулар әзірге аз.',
  'prices.parentFallback':
    '{{code}} коды бойынша аяқталған сатып алулар әзірге жоқ — «{{name}}» кеңірек санаты бойынша бағалар көрсетілген.',
  'prices.band': 'Жеңімпаз бағасы',
  'prices.band.p25': '25% — төмен',
  'prices.band.median': 'медиана',
  'prices.band.p75': '75% — жоғары',
  'prices.discount': 'Бастапқы бағадан медианалық жеңілдік',
  'prices.basedOn': 'дереккөз бастапқы бағаны жариялайтын үлгідегі {{n}} сатып алу бойынша',
  'prices.discountUnknown':
    'деректер жоқ: дереккөз бастапқы бағаны түпкілікті ретінде жазады ({{n}} сатып алу)',
  'prices.noSourceData': 'дереккөз бұл деректерді жарияламайды',
  'prices.sampleNoDates': 'Үлгі: {{n}} сатып алу · дереккөз күндерді жарияламайды',
  'prices.sortBy': 'Сұрыптау:',
  'prices.sortCount': 'Деректер көлемі бойынша',
  'prices.sortName': 'Атауы бойынша',
  'prices.participants': 'Қатысушылар медианасы',
  'prices.sample': 'Үлгі: {{n}} сатып алу · {{from}}–{{to}}',
  'prices.direct':
    'Тікелей шарттар бойынша (саудасыз): {{n}}, медиана {{median}}. Олар баға ауқымына кірмейді.',
  'prices.caveat': 'Санат бойынша келісімшарт құны көрсетілген, тауар бірлігінің бағасы емес.',
  'nav.prices': 'Бағалар',
  'nav.results': 'Нәтижелер',
  // «Próximos vencimientos» — Spain only; neutral text for parity.
  'nav.expiring': 'Аяқталатын келісімшарттар',
  'expiring.title': 'Мерзімі аяқталатын келісімшарттар',
  'expiring.intro':
    'Мерзімі жақында аяқталатын келісімшарттар: аяқталғаннан кейін тапсырыс беруші әдетте жаңа сатып алу жариялайды.',
  'expiring.note':
    'Күн жеңімпаз анықталған (немесе шарт жасалған) күн мен шарт мерзімі бойынша есептелген. Бұл болжам, кепілдік емес: шарт ұзартылуы немесе ертерек қайта жариялануы мүмкін. Шағын және 6 айдан қысқа шарттар көрсетілмейді.',
  'expiring.seoTitle': 'Мерзімі аяқталатын мемлекеттік келісімшарттар',
  'expiring.seoDesc':
    'Алдағы 3, 6 және 12 айда мерзімі аяқталатын мемлекеттік келісімшарттар: тапсырыс беруші, пән, код және өңір.',
  'expiring.windowAria': 'Мерзім',
  'expiring.window.3m': '3 ай',
  'expiring.window.6m': '6 ай',
  'expiring.window.12m': '12 ай',
  'expiring.filter.search': 'Пән немесе тапсырыс беруші бойынша іздеу',
  'expiring.filter.allRegions': 'Барлық өңірлер',
  'expiring.filter.allCpv': 'Барлық салалар',
  'expiring.filter.buyer': 'Тапсырыс беруші: {{name}}',
  'expiring.filter.clearBuyer': 'Тапсырыс беруші сүзгісін алып тастау',
  'expiring.count': 'Осы мерзімдегі келісімшарттар: {{count}}',
  'expiring.empty': 'Бұл мерзімде мұндай сүзгілермен келісімшарт жоқ.',
  'expiring.emptyReset': 'Сүзгілерді тазалау',
  'expiring.noSubject': 'Сипаттамасыз келісімшарт',
  'expiring.filterByBuyer': 'Тек осы тапсырыс беруші',
  'expiring.term': '{{start}} — {{end}}',
  'expiring.winner': 'Қазіргі орындаушы',
  'expiring.locked': 'Орындаушы мен сома — Pro-да',
  'expiring.endsOn': 'Аяқталу күні: {{date}}',
  'expiring.today': 'Бүгін аяқталады',
  'expiring.inOneDay': 'Ертең аяқталады',
  'expiring.inDays': 'Қалған күндер: {{count}}',
  'expiring.extendable': 'Ұзартуға болады',
  'baseRates.pricesLink': 'Санат бойынша толық баға тарихы →',
  'similarWinners.title': 'Ықтимал қатысушылар',
  'similarWinners.subtitle': 'Қатысуы ықтимал — соңғы бір жылда осындай келісімшарттар алған',
  'similarWinners.hint':
    'Соңғы 12 айда дәл сол ЕНС ТРУ коды бойынша келісімшарт алған компаниялар — сауда арқылы да, тікелей де. Нақты код бойынша компаниялар үшеуден аз болса — код класы (алғашқы 6 цифр) бойынша.',
  'similarWinners.teaserBasis': 'Бір жылда {{awards}} · {{winners}}',
  'similarWinners.teaserCompanyN': 'Компания № {{n}}',
  'similarWinners.share': 'Келісімшарттар үлесі',
  'similarWinners.basisExact': 'ЕНС ТРУ коды {{code}}: 12 айда {{awards}}, {{winners}}',
  'similarWinners.basisClass':
    'ЕНС ТРУ класы {{code}} — нақты код бойынша компаниялар аз: 12 айда {{awards}}, {{winners}}',
  'similarWinners.wins.one': '{{n}} келісімшарт',
  'similarWinners.wins.few': '{{n}} келісімшарт',
  'similarWinners.wins.many': '{{n}} келісімшарт',
  'similarWinners.companies.one': '{{n}} компания',
  'similarWinners.companies.few': '{{n}} компания',
  'similarWinners.companies.many': '{{n}} компания',
  'companyList.showAll': 'Барлығын көрсету ({{n}})',
  'companyList.last': 'соңғысы',
  'companyList.search': 'Компанияны табу',
  'companyList.notFound': 'Ештеңе табылмады',
  'companyList.close': 'Жабу',
  'companyList.share': 'үлес {{pct}}%',
  'companyList.loading': 'Тізім жүктелуде…',
  'companyList.error': 'Тізімді жүктеу мүмкін болмады',
  'companyList.truncated': '{{total}} ішінен алғашқы {{n}} көрсетілген',
  'companyList.approxDate': 'Өтінім беру мерзімі: алаң нәтиже күнін жарияламайды',
  'companyList.kind.tender': 'сауда',
  'companyList.kind.direct': 'тікелей',
  'companyList.kind.mixed': 'сауда және тікелей',
  'supplierGraph.title': 'Тапсырыс берушінің жеткізушілер шоғырлануы',
  'supplierGraph.hint':
    'Бұл тапсырыс берушінің сатып алулары қанша жеткізушіде шоғырланған және жаңа қатысушыға кіру оңай ма. Келісімшарт аз болса, қорытынды сақ: 10-ға дейін ол болжамды, 5-ке дейін жоқ — тек сандар. Конкурссыз тікелей шарттар есепке алынбайды.',
  'supplierGraph.teaserSuppliers': 'Жеңімпаздар және олардың үлестері',
  'supplierGraph.teaserConcentration': 'Шоғырлану',
  'supplierGraph.teaserSupplierN': '№ {{n}} жеткізуші',
  'supplierGraph.teaserBasis': 'Тапсырыс беруші тарихында {{contracts}} · {{suppliers}}',
  'supplierProfile.title': 'Жеткізуші профилі',
  // Chile: a natural person's page (`companyIdForm.naturalPerson`).
  'supplierProfile.titlePerson': 'Жеткізуші профилі',
  'supplierProfile.back': '← Артқа',
  'supplierProfile.locked': 'Жеткізуші профильдері Pro тарифінде қолжетімді.',
  'supplierProfile.lockedCta': 'Pro рәсімдеу',
  'supplierProfile.empty': 'Бұл жеткізуші бойынша әзірге деректер жоқ.',
  'supplierProfile.contracts': 'Келісімшарттар',
  'supplierProfile.totalValue': 'Келісімшарттар сомасы',
  'supplierProfile.avgValue': 'Орташа келісімшарт',
  'supplierProfile.buyers': 'Тапсырыс берушілер',
  'supplierProfile.tenure': 'Нарықта',
  'supplierProfile.tenureUnknown': 'дереккөз сатып алу күндерін жарияламайды',
  'supplierProfile.p12.title': '12 айдағы мемлекеттік сатып алулар',
  'supplierProfile.p12.wins': 'Келісімшарттар',
  'supplierProfile.p12.value': 'Келісімшарттар сомасы',
  'supplierProfile.p12.discount': 'Бастапқы бағадан медианалық жеңілдік',
  'supplierProfile.p12.discountNote': 'бастапқы бағасы бар {{n}} келісімшарт бойынша',
  'supplierProfile.p12.participants': 'Жеңген лоттардағы қатысушылар медианасы',
  'supplierProfile.p12.bids': 'Толық мәліметті қатысу',
  'supplierProfile.p12.bidsNote':
    'дереккөз барлық қатысушыларды жариялайтын {{n}} лоттың {{wins}} жеңісі; қатысудың толық үлесі белгісіз',
  'supplierProfile.p12.source':
    '{{brand}} дерекқорындағы мемлекеттік сатып алу қорытындылары бойынша, жеңімпазды анықтау күні соңғы 12 айда.',
  'supplierProfile.topBuyers': 'Негізгі тапсырыс берушілер',
  'supplierProfile.categories': 'Санаттар',
  'supplierProfile.recentContracts': 'Соңғы келісімшарттар',
  'supplierProfile.allContracts': 'Келісімшарттар',
  'supplierProfile.contractsMore': 'Тағы көрсету',
  'supplierProfile.regions': 'Аймақтар',
  'supplierProfile.debarred': 'Адал емес жеткізушілер тізілімінде',
  'supplierProfile.nContracts': '{{n}} келісім.',
  'buyer.title': 'Тапсырыс беруші профилі',
  'buyer.back': '← Артқа',
  'buyer.locked':
    'Бұл тапсырыс берушінің жеткізушілері, үлестері және қайталанатын жеңімпаздары — Pro тарифінде.',
  'buyer.lockedCta': 'Pro рәсімдеу',
  'buyer.tin': 'БСН',
  'org.tinNumber': 'БСН {{number}}',
  'buyer.seoTitle': '«{{name}}» — БСН {{tin}}: сатып алулар және жеткізушілер',
  'buyer.seoDescription':
    '{{name}}, БСН {{tin}} — {{value}} сомасына {{awards}} келісімшарт, {{suppliers}} жеткізуші, {{active}} белсенді тендер. Санаттар мен сомалар — {{brand}}.',
  'supplier.seoTitle':
    '«{{name}}» — БСН/ЖСН {{tin}}: мемлекеттік сатып алулар, келісімшарттар, жеңістер',
  'supplier.seoDescription':
    '{{name}}, БСН/ЖСН {{tin}} — {{value}} сомасына {{contracts}} мемлекеттік келісімшарт, {{buyers}} тапсырыс беруші, {{period}}. Жеткізу санаттары мен аймақтары — {{brand}}.',
  'buyer.empty': 'Бұл тапсырыс беруші бойынша әзірге деректер жоқ.',
  'buyer.dependenceFlag': 'Бір жеткізушіге тәуелділік — шығыстардың {{pct}}%',
  'buyer.kpi.awards': 'Келісімшарттар',
  'buyer.kpi.value': 'Келісімшарттар сомасы',
  'buyer.kpi.suppliers': 'Жеткізушілер',
  'buyer.kpi.active': 'Белсенді тендерлер',
  'buyer.p12.title': '12 айдағы сатып алулар',
  'buyer.p12.awards': 'Жасалған келісімшарттар',
  'buyer.p12.value': 'Келісімшарттар сомасы',
  'buyer.p12.discount': 'Бастапқы бағадан медианалық жеңілдік',
  'buyer.p12.discountNote': 'бастапқы бағасы бар {{n}} лот бойынша',
  'buyer.p12.participants': 'Қатысушылар медианасы',
  'buyer.p12.participantsNote': 'қатысушылар саны бар {{n}} лот бойынша',
  'buyer.p12.singleBidder': 'Бір қатысушысы бар лоттар',
  'buyer.p12.source':
    '{{brand}} дерекқорындағы мемлекеттік сатып алу қорытындылары бойынша, жеңімпазды анықтау күні соңғы 12 айда.',
  'buyer.settlement.below': 'Келісімшарт ұсыныстан төмен',
  'buyer.settlement.above': 'Келісімшарт ұсыныстан жоғары',
  'buyer.settlement.sub': '{{n}} келісімшарт бойынша · {{pct}}% төмен',
  'buyer.settlement.source': 'Дереккөз: шарттар туралы ашық деректер',
  'buyer.favoritism': 'Шоғырлану және фаворитизм',
  'buyer.topShareSplit':
    'Үздік жеткізуші: сома бойынша {{value}}% · келісімшарт бойынша {{count}}%',
  'buyer.streak': '{{name}} қатарынан {{n}} рет жеңді',
  'buyer.winnerSub': '{{wins}} жеңіс · сома бойынша {{value}}% / келісімшарт бойынша {{count}}%',
  'buyer.awardsByYear': 'Жылдар бойынша сатып алулар',
  'buyer.categories': 'Санаттар',
  'buyer.recentAwards': 'Соңғы келісімшарттар',
  // Spain only in practice: `amountShown` is always true on UZ/KZ. Kept for key parity.
  'buyer.amountUndisclosed': 'Сома жарияланбаған',
  'buyer.recentTenders': 'Соңғы тендерлер',
  'buyer.viewProfile': 'Тапсырыс беруші профилі',
  'supplierGraph.topShare': 'Үздік жеткізуші үлесі',
  'supplierGraph.topShareBasis': '{{total}} келісімшарттың {{wins}}-і',
  'supplierGraph.locked': 'Аналитика Pro тарифінде қолжетімді',
  'supplierGraph.lockedCta': 'Тарифтерді қарау',
  'supplierGraph.insufficient': 'Бұл тапсырыс беруші бойынша деректер әзірге жеткіліксіз',
  'supplierGraph.concentration.high': 'Сатып алуларды 1–2 жеткізуші ұстап отыр',
  'supplierGraph.concentration.moderate': 'Тұрақты жеткізушілер бар',
  'supplierGraph.concentration.low': 'Жеткізушілер ауысып отырады',
  'supplierGraph.concentrationHint.high': 'Жаңа қатысушыға кіру қиын',
  'supplierGraph.concentrationHint.moderate': 'Кіруге болады, бірақ тұрақты бәсекелестер бар',
  'supplierGraph.concentrationHint.low': 'Жаңа қатысушыға кіру оңай',
  'supplierGraph.tooEarly': '{{contracts}} — шоғырлану туралы айтуға ерте',
  'supplierGraph.concentrationHedged.high': 'Сатып алулар 1–2 жеткізушіде · {{contracts}}',
  'supplierGraph.concentrationHedged.moderate': 'Тұрақты жеткізушілер бар · {{contracts}}',
  'supplierGraph.concentrationHedged.low': 'Жеткізушілер ауысып отырады · {{contracts}}',
  'supplierGraph.hhiTitle': 'HHI шоғырлану индексі {{n}}',
  'supplierGraph.dependenceFlag': 'Бір жеткізушіге жоғары тәуелділік',
  'supplierGraph.contracts.one': '{{n}} келісімшарт',
  'supplierGraph.contracts.few': '{{n}} келісімшарт',
  'supplierGraph.contracts.many': '{{n}} келісімшарт',
  'supplierGraph.suppliers.one': '{{n}} жеткізуші',
  'supplierGraph.suppliers.few': '{{n}} жеткізуші',
  'supplierGraph.suppliers.many': '{{n}} жеткізуші',
  'supplierGraph.top3Share': 'Үздік-3 үлесі',
  'supplierGraph.suppliersBasis': '{{n}} жеткізушіден',
  'supplierGraph.marketShare': 'Тапсырыс беруші нарық үлесі',
  'supplierGraph.topNShare': 'топ-{{n}} · {{pct}}%',
  'supplierGraph.footer':
    '{{suppliers}} жеткізуші · {{contracts}} келісімшарт · {{total}} {{currency}}',
  'tender.trust.title': 'Тапсырыс беруші туралы',
  'tender.trust.titleSupplier': 'Жеткізуші туралы',
  'tender.trust.vat': 'ҚҚС төлеуші',
  'tender.trust.fund': 'Жарғылық қор',
  'tender.trust.since': '{{year}} жылдан бері жұмыс істейді',
  'tender.trust.statusLabel': 'Мәртебе',
  'tender.trust.vatLabel': 'ҚҚС',
  'tender.trust.vatYes': 'Төлеуші',
  'tender.trust.sinceLabel': 'Жұмыс істейді',
  'tender.trust.status.ACTIVE': 'Жұмыс істейді, салық міндеттемелері бар',
  'tender.trust.status.TAX_FREE': 'Салық міндеттемелері жоқ',
  'tender.trust.status.INACTIVE': 'Тарату сатысында',
  'tender.trust.status.LIQUIDATED': 'Қызметін тоқтатты',
  'tender.trust.liquidated': 'Таратылды',
  'tender.trust.kgd.DEBTOR_BANKRUPT': 'Сот шешімімен банкрот деп танылған',
  'tender.trust.kgd.DEBTOR_REHABILITATION': 'Сот шешімімен оңалту рәсімі',
  'tender.trust.kgd.DEBTOR_LIQUIDATION_NO_BANKRUPTCY': 'Сот шешімімен банкроттықсыз тарату',
  'tender.trust.kgd.BANKRUPT': 'МКК банкроттар тізімінде',
  'tender.trust.kgd.PSEUDO_ENTERPRISE': 'Жалған кәсіпорын деп танылған',
  'tender.trust.kgd.REGISTRATION_INVALID': 'Тіркеу жарамсыз деп танылған',
  'tender.trust.kgd.REREGISTRATION_INVALID': 'Қайта тіркеу жарамсыз деп танылған',
  'tender.trust.kgdSource': 'ҚР ҚМ Мемлекеттік кірістер комитетінің деректері бойынша',
  // DXMAP мемлекеттік рейтингі (xarid.icppa.uz) — тек әріп; дереккөз әріптер
  // арасындағы шектерді жарияламайды. Лицензия дереккөзді көрсетуді талап етеді.
  'tender.trust.dxmapRatingLabel': 'Тұрақтылық рейтингі',
  'tender.trust.dxmapSectorLabel': 'Қызмет түрі',
  'tender.trust.dxmapSource': 'Салық комитетінің тұрақтылық рейтингі, дереккөз —',
  'requirements.title': 'Сатып алу талаптары',
  'requirements.scope': 'Сатып алу нысаны',
  'requirements.qualifications': 'Біліктілік талаптары',
  'requirements.technicalSpecs': 'Техникалық сипаттамалар',
  'requirements.delivery': 'Жеткізу мерзімдері',
  'requirements.warranty': 'Кепілдік',
  'requirements.payment': 'Төлем шарттары',
  'requirements.sourceDocuments': 'лот құжаттары бойынша',
  'requirements.sourceMarketplace': '{{name}} алаңының деректері бойынша',
  'requirements.sourceMarketplaceGeneric': 'бастапқы алаңның деректері бойынша',
  'requirements.disqualifying': 'өтінім қабылданбайды',
  'requirements.awardCriteria': 'Бағалау өлшемшарттары',
  'requirements.awardPoints.one': '{{n}} ұпай',
  'requirements.awardPoints.few': '{{n}} ұпай',
  'requirements.awardPoints.many': '{{n}} ұпай',
  'requirements.awardMethod.formula': 'формула бойынша',
  'requirements.awardMethod.judgement': 'сараптамалық баға',
  'requirements.noneStated': 'Лот құжаттарын талдадық — біліктілік талаптары оларда көрсетілмеген.',
  'requirements.noDocuments':
    '{{name}} алаңы құжаттарды осында жарияламайды — бастапқы дереккөзден қараңыз.',
  'requirements.noDocumentsGeneric': 'Бұл лоттың құжаттары тек бастапқы алаңда жарияланады.',
  'requirements.noDocumentsLocked':
    'Бұл лоттың құжаттары тек бастапқы алаңда орналасқан. Лотты алаңда ашу — Pro тарифінде.',
  'requirements.openOnSource': 'Лотты алаңда ашу',
  'requirements.unreadable':
    'Құжат сканер көшірмесі ретінде немесе біз әлі оқи алмайтын форматта тіркелген.',
  'requirements.openDocument': 'Құжатты ашу',
  'requirements.pending': 'Құжаттарды талдап жатырмыз, әдетте 2 сағатқа дейін.',
  'requirements.locked': 'Талаптарды талдау Pro тарифінде қолжетімді',
  'requirements.lockedCta': 'Тарифтерді қарау',
  'plans.checkout': 'Рәсімдеу',
  'plans.checkoutGuest': 'Рәсімдеу үшін кіру',
  'plans.redirecting': 'Бағыттауда…',
  'plans.tinRequired':
    'Бұл тариф үшін компанияның БСН/ЖСН қажет. Оны көрсетіп, төлемге қайта оралыңыз.',
  'plans.checkoutError': 'Рәсімдеу мүмкін болмады. Қайталап көріңіз.',
  'plans.loadError': 'Тарифтерді жүктеу мүмкін болмады.',
  'plans.loadRetry': 'Қайталау',
  'plans.payWithPayme': 'Картамен төлеу',
  'plans.payOnce': 'Бір реттік төлем',
  'plans.payOnceWithPrice': 'Бір реттік төлем — {{amount}}',
  'plans.payOnceNote': 'Автожаңартусыз · жазылымнан 10% қымбат',
  'plans.payOnceNoRenew': 'Автожаңартусыз бір реттік төлем',
  'plans.onceAmount': 'Төлеуге: 1 айға {{amount}}',
  'plans.payWithClick': 'Картамен төлеу',
  'plans.payOnceViaPayme': 'Картамен төлеу',
  'plans.payOnceOrLabel': 'Немесе бір рет төлеу — {{amount}}',
  'plans.payMethodLabel': 'Төлем әдісі',
  'plans.clickCards': 'Visa · Mastercard',
  'plans.paymentVia': 'Картамен төлеу',
  'plans.payByAccount': 'Есеп айырысу шоты бойынша төлем',
  'plans.invoiceSub': 'Жария оферта + бухгалтерияға арналған шот-фактура',
  'plans.orPayByCard': 'Немесе қосымша арқылы картамен төлеу',
  'plans.yearAccessNote': 'Автожаңартусыз — 12 айға қолжетімділік',
  'plans.payWithCard': 'Картамен төлеу (Visa/Mastercard)',
  'plans.payByInvoice': 'Шот бойынша төлем (заңды тұлғалар үшін)',
  'plans.paymeOnlyNote': 'Ай сайынғы төлем — тек онлайн, банк картасымен.',
  'plans.bankTransferTitle': 'Төлем үшін деректемелер',
  'plans.bankAmount': 'Төлеуге сома',
  'plans.downloadInvoice': 'Төлемге шотты жүктеп алу',
  'plans.bankNote': 'Pro тарифі есеп айырысу шотына төлем түскен соң іске қосылады.',
  'invoiceFlow.tinLabel': 'Ұйымыңыздың БСН/ЖСН',
  'invoiceFlow.tinLooking': 'Тізілімнен іздеуде…',
  'invoiceFlow.nameLabel': 'Ұйым атауы',
  'invoiceFlow.namePlaceholder': 'ЖШС «Мысал»',
  'invoiceFlow.tinIncomplete': 'БСН/ЖСН {{tinDigits}} саннан тұрады',
  'invoiceFlow.nameRequired': 'Атауын жазыңыз — ол шотта басылады',
  'invoiceFlow.accessPeriod':
    'Белсендірілген күннен бастап 12 ай қолжетімділік — бүгін төлесеңіз {{date}} дейін.',
  'invoiceFlow.issue': 'Шот жазу',
  'invoiceFlow.issuing': 'Жазылуда…',
  'invoiceFlow.errIssue': 'Шот жазу мүмкін болмады. БСН/ЖСН тексеріп, қайталап көріңіз.',
  'invoiceFlow.readyTitle': '№ {{number}} шот',
  'invoiceFlow.purposeLabel': 'Төлем мақсаты (міндетті)',
  'invoiceFlow.purposeWarning':
    'Әр шоттың өз мақсаты бар. Басқа шоттың мақсаты есептеуді кешіктіреді. Үшінші тұлғадан төлем қабылданбайды.',
  'invoiceFlow.copy': 'Көшіру',
  'invoiceFlow.copied': 'Көшірілді',
  'invoiceFlow.download': 'PDF жүктеп алу',
  'invoiceFlow.sendEmail': 'Поштаға жіберу',
  'invoiceFlow.emailSent': 'Поштаға жіберілді',
  'invoiceFlow.sendTelegram': 'Telegram-ға жіберу',
  'invoiceFlow.telegramSent': 'Telegram-ға жіберілді',
  'invoiceFlow.errSend': 'Жіберу мүмкін болмады. PDF жүктеп алыңыз немесе кейінірек қайталаңыз.',
  'invoiceFlow.errDownload':
    'PDF жүктеп алу мүмкін болмады — шотты поштаға немесе Telegram-ға жіберіңіз.',
  'invoiceFlow.errNoEmail':
    'Тіркелгіде пошта мекенжайы жоқ — PDF жүктеп алыңыз немесе Telegram-ға жіберіңіз.',
  'invoiceFlow.errNoTelegram': 'Telegram қосылмаған — оны хабарландыру баптауларында қосыңыз.',
  'invoiceFlow.connectTelegram': 'Шот пен хабарландыруларды алу үшін профильде Telegram қосыңыз',
  'invoiceFlow.activationNote': 'Қаражат түскен соң қолжетімділік 3 жұмыс күні ішінде ашылады.',
  'invoiceFlow.needFaster': 'Тезірек керек пе?',
  'invoiceFlow.savedNote':
    'Шот кабинетіңізде сақталды — оны қайта жүктеп алуға және жіберуге болады.',
  'plans.freeStart': 'Тегін бастау',
  'plans.currentPlan': 'Ағымдағы тариф',
  'plans.otherMethods': 'Басқа төлем әдістері',
  'plans.toggleMonthly': 'Ай',
  'plans.toggleYearly': 'Жыл',
  'plans.periodToggleLabel': 'Төлем кезеңі',
  'plans.badgePopular': 'Танымал',
  'plans.badgeBestValue': 'Тиімді',
  'plans.savings': 'Ай сайынғымен салыстырғанда ~{{percent}}% үнемдеу',
  'plans.badgeX2': '×{{multiple}} тиімді',
  'plans.savingsX2': 'Жыл 6 ай бағасына — {{som}} {{currency}} үнемдеу',
  'plans.refYearAria': 'Ай сайын төлесе, жылына {{som}} {{currency}} болар еді',
  'plans.consentPrefix': 'Төлеу арқылы сіз келісесіз:',
  'plans.consentOffer': 'оферта',
  'plans.consentAnd': 'және',
  'plans.consentPrivacy': 'құпиялылық саясаты',
  'plans.consentSuffix': '.',
  'footer.plans': 'Тарифтер',
  'directory.title': 'Барлық санаттар мен аймақтар',
  'directory.intro':
    'Каталог бөлімдерінің толық нұсқағышы: {{countryGen}} тендерлері мен мемлекеттік сатып алулары сатып алу бағыты және тапсырыс беруші аймағы бойынша. Әр бөлімнің қасында — ондағы белсенді тендерлер саны.',
  'directory.seoTitle': '{{countryGen}} санаттар мен аймақтар бойынша тендерлер',
  'directory.seoDesc':
    '{{countryGen}} мемлекеттік сатып алулары каталогының барлық бөлімдерінің нұсқағышы: 31 сатып алу бағыты және 14 аймақ бойынша тендерлер, әрқайсысында белсенді тендерлер саны көрсетілген.',
  'directory.categories.h2': 'Сатып алу бағыты бойынша',
  'directory.categories.intro':
    'Бағыт лоттың тауар тобымен анықталады — құрылыс материалдарынан IT мен медицинаға дейін.',
  'directory.regions.h2': 'Тапсырыс беруші аймағы бойынша',
  'directory.regions.intro': 'Аймақ — жеткізу орны емес, тапсырыс берушінің орналасқан жері.',
  'directory.companies.h2': 'Мемлекеттік сатып алуларға қатысушы компаниялар',
  'directory.companies.intro':
    '{{countryGen}} мемлекеттік сатып алуларында тарихы бар жеткізушілер мен тапсырыс берушілер каталогы: тізілімдегі мәртебесі, сенімділігі және келісімшарттар көлемі.',
  'goodStanding.tier.debarred': 'Адал еместер тізілімінде',
  'goodStanding.tier.liquidated': 'Таратылды',
  'goodStanding.tier.flagged': 'ҚДК тізілімінде (салықтық тәуекелдер)',
  'goodStanding.tier.active_supplier': 'Жұмыс істейтін жеткізуші',
  'goodStanding.tierBuyer.active_supplier': 'Жұмыс істейтін тапсырыс беруші',
  'goodStanding.tier.active': 'Жұмыс істейтін компания',
  'companies.title': '{{countryGen}} мемлекеттік сатып алуларындағы компаниялар',
  'companies.intro':
    'Мемлекеттік сатып алуларға қатысу тарихы бар жеткізушілер мен тапсырыс берушілер. Әр компанияның қасында — тізілімдегі мәртебесі және келісімшарттар көлемі.',
  'companies.seoTitle': '{{countryGen}} мемлекеттік сатып алуларына қатысушы компаниялар каталогы',
  'companies.seoTitlePaged': 'Мемлекеттік сатып алу компанияларының каталогы — {{page}}-бет',
  'companies.seoDescPaged':
    '{{countryGen}} мемлекеттік сатып алуларына қатысушы компаниялар — {{totalPages}} беттің {{page}}-і, барлығы {{count}}. Тапсырыс берушілер мен жеткізушілер, келісімшарттар мен сомалар — {{brand}} сайтында.',
  'companies.seoDesc':
    '{{countryGen}} мемлекеттік сатып алуларының жеткізушілері мен тапсырыс берушілері: әр компания бойынша тізілімдегі мәртебесі, сенімділігі және келісімшарттар тарихы.',
  'companies.search': 'Атауы немесе БСН/ЖСН',
  'companies.filter.allSectors': 'Барлық салалар',
  'companies.filter.allRegions': 'Барлық аймақтар',
  'companies.filter.allRoles': 'Барлық компаниялар',
  'companies.role.supplier': 'Жеткізушілер',
  'companies.role.buyer': 'Тапсырыс берушілер',
  'companies.role.both': 'Жеткізуші де, тапсырыс беруші де',
  'companies.rowRole.supplier': 'Жеткізуші',
  'companies.rowRole.buyer': 'Тапсырыс беруші',
  'companies.rowRole.both': 'Тапсырыс беруші әрі жеткізуші',
  'companies.contractsAs.supplier': 'Жеткізуші ретінде: {{count}} келісімшарт',
  'companies.contractsAs.buyer': 'Тапсырыс беруші ретінде: {{count}} келісімшарт',
  'companies.contracts': '{{count}} келісімшарт',
  'companies.empty': 'Компаниялар табылмады. Сүзгілерді өзгертіңіз.',
  'companies.loadMore': 'Тағы көрсету',
  'companies.count': 'Табылған компаниялар: {{count}}',
  'nav.companies': 'Компаниялар',
  'nav.guide': 'Қалай қатысу керек',
  'footer.directory': 'Санаттар мен аймақтар',
  'footer.about': 'Қызмет туралы',
  'footer.guide': 'Жеткізушілерге арналған нұсқаулық',
  'footer.offer': 'Жария оферта',
  'footer.privacy': 'Құпиялылық',
  'footer.requisites': 'Деректемелер',
  'footer.support': 'Қолдау',
  // Cookie consent (`features.cookieConsent`): only a consent deployment (MiLicita, es)
  // renders the banner; ru/uz/kk carry the keys for parity.
  'footer.cookieSettings': 'Cookie баптаулары',
  'cookieBanner.title': 'Cookie файлдары',
  'cookieBanner.text':
    'Біз сайттың жұмысына қажетті өз техникалық cookie файлдарымызды пайдаланамыз. Тек сіздің келісіміңізбен сайттың қалай пайдаланылатынын талдау, жарнамалық науқандарымызды өлшеу және браузердегі әрекеттеріңіздің профилі негізінде Meta (Facebook және Instagram) желісінде сізге жарнама көрсету үшін өз және үшінші тараптың cookie файлдарын да пайдаланамыз. Барлығын қабылдауға, барлығынан бас тартуға немесе «Баптау» бөлімінде мақсаты бойынша таңдауға болады.',
  'cookieBanner.policy': 'Cookie саясаты',
  'cookieBanner.accept': 'Барлығын қабылдау',
  'cookieBanner.reject': 'Барлығынан бас тарту',
  // Cookie-banner first layer (Spain only); kept for key parity.
  'cookieBanner.acceptShort': 'Қабылдау',
  'cookieBanner.rejectShort': 'Бас тарту',
  'cookieBanner.configure': 'Баптау',
  'cookieBanner.settingsTitle': 'Cookie баптаулары',
  'cookieBanner.settingsIntro':
    'Қандай cookie файлдарына рұқсат беретініңізді таңдаңыз. Таңдауыңызды кез келген уақытта әр беттің төменгі жағындағы «Cookie баптаулары» сілтемесі арқылы өзгерте аласыз.',
  'cookieBanner.always': 'Әрдайым қосулы',
  'cookieBanner.save': 'Таңдауды сақтау',
  'cookieBanner.technical.name': 'Техникалық',
  'cookieBanner.technical.desc':
    'Сайттың жұмысына қажет: кіру, қауіпсіздік және осы таңдауды есте сақтау. Оларды өшіруге болмайды.',
  'cookieBanner.analytics.name': 'Аналитикалық',
  'cookieBanner.analytics.desc':
    '{{brand}} қалай пайдаланылатынын өлшеп, оны жақсартуға көмектеседі (PostHog және біздің өз келу есебіміз).',
  'cookieBanner.marketing.name': 'Жарнамалық',
  'cookieBanner.marketing.desc':
    'Meta (Facebook және Instagram) желісіне науқандарымызды өлшеуге және браузердегі профиліңіз бойынша сізге жарнама көрсетуге мүмкіндік береді (Meta пикселі және Conversions API).',
  'nav.about': 'Қызмет туралы',
  'nav.subscription': 'Жазылым',
  'about.pageTitle': '{{brand}} қызметі туралы',
  'about.subtitle': '{{countryGen}} мемлекеттік тендерлері мен сатып алуларының агрегаторы.',
  'about.lead':
    '{{brand}} — {{countryGen}} мемлекеттік сатып алуларының бірыңғай каталогы. Біз тендерлерді ресми алаңдардан бір жерге жинаймыз, сатып алуларға орыс тілінде талдау қосамыз және жеткізушілерге сәйкес мемлекеттік келісімшарттарды жылдамырақ табуға көмектесеміз.',
  'about.what.title': 'Біз не істейміз',
  'about.what.body':
    'Біз бірнеше сағат сайын бюджеттік мемлекеттік сатып алулар каталогын жаңартамыз, әр тендердің аймағын, санатын және нысанын анықтаймыз және оларды іздеуге ыңғайлы етеміз — сізге ондаған алаңды қолмен қадағалаудың қажеті болмайды.',
  'about.feature.catalog.title': 'Бірыңғай каталог',
  'about.feature.catalog.desc':
    'Аймақ, санат, бюджет және өтінім беру мерзімі бойынша сүзгілері бар мыңдаған өзекті тендерлер.',
  'about.feature.ai.title': 'Сатып алуларды талдау',
  'about.feature.ai.desc':
    'Әр тендердің орыс тіліндегі қысқаша сипаттамасы — сатып алудың мәні бірден түсінікті.',
  'about.feature.search.title': 'Ақылды іздеу',
  'about.feature.search.desc':
    'Семантикалық іздеу сұраудың мағынасын түсінеді, тек нақты сөздерді емес.',
  'about.feature.alerts.title': 'Telegram-ға және поштаға хабарландырулар',
  'about.feature.alerts.desc':
    'Іздеуді сақтап, жаңа сәйкес тендерлер туралы бірінші болып біліңіз.',
  'about.audience.title': 'Кімге арналған',
  'about.audience.body':
    '{{countryGen}} мемлекеттік сатып алуларына қатысатын және сәйкес тендерлерді бірінші болып көргісі келетін жеткізушілер, мердігерлер және өндірушілер үшін.',
  'about.sources.title': 'Деректер көздері',
  'about.sources.body':
    'Біз {{countryGen}} мемлекеттік сатып алуларының ресми алаңдарынан жария деректерді жинаймыз. {{brand}} — тәуелсіз қызмет және мемлекеттік портал болып табылмайды.',
  'about.press.title': 'Біз туралы жазады',
  'about.contact.title': 'Бізбен байланысу',
  'about.contact.body': 'Ынтымақтастық, жазылым және қолдау мәселелері бойынша бізге жазыңыз:',
  'about.operator': 'Қызмет операторы — {{legalName}}.',
  'about.operator.requisitesLink': 'Деректемелер',
  'footer.rights': 'Барлық құқықтар қорғалған.',
  'footer.inn': 'СТН',
  'footer.phone': 'Телефон',
  'legal.updated': 'Соңғы жаңарту',
  'legal.requisitesHeading': 'Орындаушының деректемелері',
  'requisites.pageTitle': 'Деректемелер',
  'requisites.subtitle': 'Қызмет операторының заңды және банктік деректемелері.',
  'requisites.note':
    'Жазылым үшін карта арқылы төлемдерді Stripe төлем жүйесі арқылы AI CRM Inc (АҚШ) қабылдайды.',
  'invoice.pageTitle': 'Төлемге шот',
  'invoice.title': 'Төлемге шот',
  'invoice.date': 'Күні',
  'invoice.back': '← Тарифтерге',
  'invoice.print': 'Басып шығару / PDF',
  'invoice.seller': 'Жеткізуші (Орындаушы)',
  'invoice.buyer': 'Төлеуші (Тапсырыс беруші)',
  'invoice.buyerName': 'Атауы',
  'invoice.buyerInn': 'СТН',
  'invoice.itemName': 'Қызмет атауы',
  'invoice.itemQty': 'Саны',
  'invoice.itemPrice': 'Сома',
  'invoice.itemPlan': '{{name}} жазылымы (жылдық), {{brandHost}} қызметіне қолжетімділік',
  'invoice.total': 'Төлеуге барлығы',
  'invoice.note':
    'Көрсетілген соманы жеткізушінің есеп айырысу шотына төлеңіз. {{name}} тарифі қаражат түскен соң іске қосылады. Төлем мақсаты: {{name}} жазылымын төлеу, {{brandHost}}.',
  'tender.budgetLabel': 'Бюджет',
  'tender.deadlineLabel': 'Мерзім',
  'tender.daysLeftText': '{{days}} қалды',
  'tender.nav.description': 'Сипаттама',
  'tender.nav.procedure': 'Тәртіп',
  'tender.nav.documents': 'Құжаттар',
  'tender.nav.lotDetails': 'Жеткізу',
  'tender.identity.platform': 'Алаң',
  'tender.lotDetails.title': 'Жеткізу шарттары',
  'tender.lotDetails.unitPrice': 'Бір бірлік бағасы',
  'tender.lotDetails.qty': 'Саны',
  'tender.lotDetails.unit': 'Өлшем бірлігі',
  'tender.lotDetails.deliveryPlace': 'Жеткізу орны',
  'tender.lotDetails.deliveryTerm': 'Жеткізу мерзімі',
  'tender.lotDetails.advancePct': 'Аванс',
  'tender.lotDetails.paymentType': 'Төлем шарттары',
  'tender.lotDetails.paymentTermDays': 'Төлем мерзімі',
  'tender.lotDetails.positions': 'Лот позициялары: {{n}}',
  'tender.lotDetails.incoterms': 'Инкотермс',
  'tender.lotDetails.purchaseType': 'Сатып алу түрі',
  'tender.lotDetails.batchLotCount': 'Хабарландырудағы лоттар',
  'tender.lotDetails.batchTotal': 'Сатып алу сомасы',
  'tender.lotDetails.legalAddress': 'Тапсырыс берушінің заңды мекенжайы',
  'tender.positions.title': 'Не сатып алынады',
  'tender.positions.unitPrice': 'бірлік бағасы {{price}}',
  'tender.positions.total': 'барлығы {{sum}}',
  'tender.positions.showAll': 'Барлық позицияларды көрсету ({{n}})',
  'tender.positions.collapse': 'Жию',
  'tender.positions.capped': 'Көрсетілген позициялар: {{shown}} / {{n}}',
  'tender.nav.requirements': 'Талаптар',
  'tender.nav.contacts': 'Байланыстар',
  'tender.nav.integrity': 'Параметрлер',
  'tenderIntegrity.title': 'Рәсім параметрлері',
  'tenderIntegrity.hint':
    'Назар аударуға тұрарлық белгілер: қайта қою, жалғыз қатысушы, кепіл, талаптар. Тек фактілер, бағасыз.',
  'tenderIntegrity.teaserRelisting': 'Лотты қайта қою',
  'tenderIntegrity.teaserDeposit': 'Бюджетке кепіл',
  'tenderIntegrity.teaserBasis': 'Лот құжаттамасы бойынша тексерулер: {{n}}',
  'tenderIntegrity.relisting': '#{{id}} рәсімінен қайта қойылды',
  'tenderIntegrity.prevFailed': 'алдыңғысы өтпеді',
  'tenderIntegrity.prevParticipants': 'ондағы қатысушылар: {{n}}',
  'tenderIntegrity.participants': 'Тіркелген қатысушылар: {{n}}',
  'tenderIntegrity.single': 'Жалғыз тіркелген қатысушы',
  'tenderIntegrity.deposit': 'Кепіл — бюджеттің {{pct}}%',
  'tenderIntegrity.median': 'бөлім бойынша медиана — {{pct}}%',
  'tenderIntegrity.quals': 'Дисквалификациялайтын талаптар: {{n}}',
  'tenderIntegrity.qualsShow': 'Талаптарды көрсету',
  'tenderIntegrity.weights': 'бағалау {{tech}}:{{cost}} (техника:баға)',
  'tenderIntegrity.source': 'Рәсім хаттамалары мен сатып алу графигі бойынша',
  'tender.callAction': 'Қоңырау шалу',
  'tender.summaryLabel': 'Сипаттама',
  'tender.detailLabel': 'Сипаттама',
  'tender.overview.description': 'Сипаттама',
  'tender.overview.specification': 'Спецификация',
  'tender.overview.bidSecurity': 'Өтінімді қамтамасыз ету',
  'tender.documentTextLabel': 'Құжаттама мәтіні',
  'tender.noSummary': 'Бұл тендер үшін түйіндеме әзірге қолжетімсіз.',
  'tender.reveal.title': 'Тапсырыс берушінің байланыстары',
  'tender.reveal.remaining': 'Осы ай ішінде қалған ашулар: {{count}}',
  'tender.reveal.action': 'Байланыстарды көрсету',
  'tender.reveal.titleNoContact': 'Хабарландырудың түпнұсқасы',
  'tender.reveal.noContactHint':
    'Тапсырыс беруші бұл тендер бойынша байланыстарды жарияламаған. Ашу алаңдағы хабарландырудың түпнұсқасына сілтеме береді.',
  'tender.reveal.actionNoContact': 'Түпнұсқаны ашу',
  'tender.reveal.pending': 'Ашылуда…',
  'tender.reveal.ceiling':
    'Бұл тендердің бюджеті тарифіңіздің лимитінен жоғары. Мұндай тендерлер бойынша байланыстар Pro тарифінде қолжетімді.',
  'tender.reveal.exhausted':
    'Осы айға байланыстарды ашу лимиті таусылды. Лимит 1-ші күні жаңарады — немесе лимитсіз Pro тарифіне өтіңіз.',
  'tender.reveal.error': 'Байланыстарды ашу мүмкін болмады. Қайталап көріңіз.',
  // ── Per-account read ceiling ────────────────────────────────────────────
  // Бұл қабырға да, Pro жарнамасы да ЕМЕС: мұнда байланысқа құқығы бар
  // қолданушы ғана түседі. {{limit}} серверден келеді, {{time}} — тәуліктік
  // терезенің қайта ашылу сәті (UTC, яғни Ташкент уақытымен 05:00).
  'tender.reveal.limitedDay':
    'Бүгінге байланыс ашу лимиті таусылды ({{limit}}). Лимит Астана уақытымен {{time}}-де жаңарады. Егер бұл қате болса — қолдау қызметіне жазыңыз.',
  'tender.reveal.limitedMinute':
    'Сіз қатарынан тым көп байланыс аштыңыз. Бір минут күтіп, қайталап көріңіз. Егер бұл қате болса — қолдау қызметіне жазыңыз.',
  'tender.reveal.limitedSupport': 'Қолдау қызметіне жазу',

  // «Пакет заявки» — за флагом BID_PACKAGE_ENABLED, только для Pro.
  'tender.bidPackage.title': 'Пакет заявки',
  'tender.bidPackage.cta': 'Собрать заявку',
  'tender.bidPackage.statusIdle': 'Не собран',
  'tender.bidPackage.statusReady': 'Готов',
  'tender.bidPackage.statusReadyOn': 'Готов · собран {{date}}',
  'tender.bidPackage.statsDocs': 'обязательных документов {{n}}',
  'tender.bidPackage.statsGaps': 'пропусков {{n}}',
  'tender.bidPackage.statsProfile': 'анкета заполнена {{pct}} %',
  'tender.bidPackage.profileFill': 'Заполнить анкету компании →',
  'tender.bidPackage.details': 'Открыть подробности',
  'tender.bidPackage.detailsHide': 'Скрыть подробности',
  'tender.bidPackage.gateWarn': 'Пакет выйдет с пропусками: анкета заполнена {{pct}} %.',
  'tender.bidPackage.gateLink': 'Заполнить →',
  'tender.bidPackage.building': 'Создаётся…',
  'tender.bidPackage.preparing': 'Готовим документ, пришлём на почту',
  'tender.bidPackage.preparingHint':
    'Можно закрыть страницу — обычно занимает 10–30 секунд. Готовый пакет останется и здесь.',
  'tender.bidPackage.failed': 'Не получилось собрать пакет.',
  'tender.bidPackage.retry': 'Повторить',
  'tender.bidPackage.error': 'Не удалось собрать пакет. Попробуйте ещё раз.',
  'tender.bidPackage.errorNotGranted': 'Доступ к пакету заявки для вашего аккаунта сейчас закрыт.',
  'tender.bidPackage.errorMonthlyLimit':
    'Лимит на этот месяц исчерпан — 3 сборки в месяц. Уже собранные пакеты открываются без ограничений, лимит обновится 1-го числа.',
  'tender.bidPackage.errorGrantLimit':
    'Сборки по вашему доступу закончились. Уже собранные пакеты открываются без ограничений — напишите нам, если нужно больше.',
  'tender.bidPackage.errorRegenCooldown':
    'Пересобрать этот пакет можно раз в час. Текущая версия остаётся доступной.',
  'tender.bidPackage.downloadError': 'Не удалось скачать файл. Попробуйте ещё раз.',
  'tender.bidPackage.stale': 'Объявление изменилось после того, как пакет был собран.',
  'tender.bidPackage.rebuild': 'Собрать заново',
  'tender.bidPackage.regenerate': 'Пересобрать',
  'tender.bidPackage.ctaClosed': 'Приём заявок закрыт',
  'tender.bidPackage.errorTenderClosed':
    'Приём заявок по этому лоту закрыт — собрать пакет уже нельзя.',
  'tender.bidPackage.rebuildFailed': 'Пересборка не удалась, показан прежний документ',
  'tender.bidPackage.warnClosingSoon': 'До конца приёма меньше суток.',
  'tender.bidPackage.warnUzMachineTranslated':
    'Узбекская версия переведена автоматически — проверьте перед подачей.',
  'tender.bidPackage.checkedAgainst': 'Проверено по данным компании {{company}}',
  'tender.bidPackage.noCompany':
    'БИН/ИИН в профиле не указан, поэтому проверить требования по вашей компании мы не смогли — все пункты нужно проверить самостоятельно.',
  'tender.bidPackage.admissionOk': 'Можно подавать',
  'tender.bidPackage.admissionBlocked': 'Есть препятствия: {{count}}',
  'tender.bidPackage.admissionTitle': 'Проверка допуска',
  'tender.bidPackage.deadlineLabel': 'Приём до',
  'tender.bidPackage.methodLabel': 'Способ подачи',
  'tender.bidPackage.methodUnknown':
    'площадка ведёт несколько процедур — вид смотрите на карточке лота',
  'tender.bidPackage.submitTitle': 'Куда и как подать',
  'tender.bidPackage.submitEntry': 'Вход на площадку',
  'tender.bidPackage.profileTitle': 'Анкета компании — только недостающее',
  'tender.bidPackage.profileLead':
    'Эти поля не публикует ни один реестр, а формам в пакете они нужны. Спросим один раз.',
  'tender.bidPackage.profileContinue': 'Продолжить',
  'tender.bidPackage.profileSaving': 'Сохраняем…',
  'tender.bidPackage.profileSaveError': 'Не удалось сохранить анкету. Попробуйте ещё раз.',
  'tender.bidPackage.profileSkipHint':
    'Любое поле можно пропустить — в документе на его месте будет видимый пропуск, который вы заполните сами.',
  'tender.bidPackage.profileLink': 'Остальные данные компании — в профиле',
  'tender.bidPackage.groupAuto': 'Проверено по вашим данным',
  'tender.bidPackage.groupAutoHint':
    'Подтверждено по реестру и истории побед. Это не заменяет проверку комиссией.',
  'tender.bidPackage.groupManual': 'Проверьте сами',
  'tender.bidPackage.groupManualHint':
    'Обязательные требования, которые можем подтвердить только вы: сертификаты, справки, нотариальные копии.',
  'tender.bidPackage.groupSoft': 'Пожелания заказчика',
  'tender.bidPackage.emptyGroup': 'В объявлении не указано.',
  'tender.bidPackage.evidence': 'Подтверждается: {{value}}',
  'tender.bidPackage.verdict.ok': 'соответствуете',
  'tender.bidPackage.verdict.fail': 'не проходите',
  'tender.bidPackage.basis.registration': 'По реестру: {{value}}',
  'tender.bidPackage.basis.region': 'Регион компании: {{value}}',
  'tender.bidPackage.basis.legal_form': 'Организационная форма: {{value}}',
  'tender.bidPackage.basis.vat': 'Плательщик НДС: {{value}}',
  'tender.bidPackage.basis.experience': 'Побед в этой отрасли: {{value}}',
  'tender.bidPackage.documents': 'Документы к заявке',
  'tender.bidPackage.mandatory': 'обязательный',
  'tender.bidPackage.optional': 'по желанию',
  'tender.bidPackage.coverLetter': 'Заявка на участие — черновик',
  'tender.bidPackage.offer': 'Коммерческое предложение — черновик',
  'tender.bidPackage.offerHint': 'Цены не заполняем: их ставите вы.',
  'tender.bidPackage.uzMark': 'проверьте',
  'tender.bidPackage.uzMarkHint':
    'Текст переведён на узбекский автоматически — сверьте перед подачей.',
  'tender.bidPackage.colItem': 'Наименование',
  'tender.bidPackage.colQty': 'Кол-во',
  'tender.bidPackage.colUnit': 'Ед.',
  'tender.bidPackage.colPrice': 'Цена за ед.',
  'tender.bidPackage.download': 'Скачать DOCX',
  'tender.bidPackage.downloading': 'Готовим файл…',
  'tender.bidPackage.sendEmail': 'На почту',
  'tender.bidPackage.sendTelegram': 'В Telegram',
  'tender.bidPackage.sending': 'Отправляем…',
  'tender.bidPackage.sentEmail': 'Отправили на почту.',
  'tender.bidPackage.sentTelegram': 'Отправили в Telegram.',
  'tender.bidPackage.sendHint':
    'Если файл не скачивается — встроенный браузер приложения так умеет, — заберите его почтой.',
  'tender.bidPackage.sendError': 'Не удалось отправить. Попробуйте ещё раз.',
  'tender.bidPackage.sendNoEmail': 'У аккаунта нет почтового адреса — добавьте его в профиле.',
  'tender.bidPackage.sendNoTelegram': 'Telegram не подключён — привяжите бота в профиле.',
  'tender.bidPackage.disclaimer':
    'Черновик, подготовленный автоматически по тексту объявления и приложенных файлов. Перед подачей сверьте с оригиналом — ответственность за содержание заявки несёт участник.',

  // ── «Подготовить тендерную документацию» — кнопка листа ожидания на лоте. Как и
  // блок пакета заявки выше, на KZ-развёртывании пока по-русски (ключи — ради parity).
  'tender.bidWaitlist.cta': 'Подготовить тендерную документацию (beta)',
  'tender.bidWaitlist.caption': 'Пакет документов для подачи заявки по этому лоту',
  'tender.bidWaitlist.queued': 'Вы в очереди',
  'tender.bidWaitlist.queuedCaption': 'Откроем доступ и напишем в Telegram',
  'tender.bidWaitlist.error': 'Не получилось встать в очередь. Попробуйте ещё раз.',
  'tender.bidWaitlist.captionReprompt': 'Дополните анкету',
  'tender.bidWaitlist.queuedCaptionEmail': 'Откроем доступ и напишем на почту',

  // ── Анкета за этой кнопкой (components/bid-waitlist-form-modal.tsx, 2026-09-29).
  // Как и блок выше, на KZ-развёртывании пока по-русски (ключи — ради parity).
  // ⚠️ Шкала вознаграждения — в сумах, как её задал владелец для UZ; условий для
  // KZ он не задавал. Анкета открывается только платящему, а касса KZ пока stub.
  'tender.bidWaitlistForm.title': 'Документация для заявки',
  'tender.bidWaitlistForm.beta': 'бета',
  'tender.bidWaitlistForm.intro':
    'Собираем пакет заявки по документации лота: требования, формы и черновики документов. Доступ открываем по очереди.',
  'tender.bidWaitlistForm.termsTitle': 'Условия после беты',
  'tender.bidWaitlistForm.termsLead':
    'Если вы победите с нашей документацией — договор и вознаграждение от суммы контракта:',
  'tender.bidWaitlistForm.tier1Range': 'до 100 млн {{currency}}',
  'tender.bidWaitlistForm.tier1Fee': 'до 5 %',
  'tender.bidWaitlistForm.tier2Range': 'до 10 млрд',
  'tender.bidWaitlistForm.tier2Fee': 'до 1 %',
  'tender.bidWaitlistForm.tier3Range': 'свыше 10 млрд',
  'tender.bidWaitlistForm.tier3Fee': 'до 0,5 %',
  'tender.bidWaitlistForm.termsUpload':
    'После подачи вы загружаете нам поданную заявку — по ней мы улучшаем следующую.',
  'tender.bidWaitlistForm.tinLabel': '{{tin}} компании',
  'tender.bidWaitlistForm.tinPlaceholder': '{{tinDigits}} сан',
  'tender.bidWaitlistForm.tinHint': 'по нему увидим ваши победы',
  'tender.bidWaitlistForm.tinMissing': 'Укажите {{tin}} компании — {{tinDigits}} цифр',
  'tender.bidWaitlistForm.supplyLabel': 'Не жеткізесіз',
  'tender.bidWaitlistForm.supplyPlaceholder': 'мебель, канцтовары, ремонт кровли',
  'tender.bidWaitlistForm.bidsLabel': 'Сколько тендеров подаёте в месяц',
  'tender.bidWaitlistForm.bids.0': '0',
  'tender.bidWaitlistForm.bids.1_3': '1–3',
  'tender.bidWaitlistForm.bids.4_10': '4–10',
  'tender.bidWaitlistForm.bids.10_plus': 'больше 10',
  'tender.bidWaitlistForm.preparerLabel': 'Кто сейчас готовит документы',
  'tender.bidWaitlistForm.preparer.self': 'сами',
  'tender.bidWaitlistForm.preparer.employee': 'сотрудник',
  'tender.bidWaitlistForm.preparer.broker': 'брокер',
  'tender.bidWaitlistForm.brokerPercentLabel': 'под какой процент',
  'tender.bidWaitlistForm.lotLabel': 'Обычная сумма лота',
  'tender.bidWaitlistForm.lot.to_100m': 'до 100 млн',
  'tender.bidWaitlistForm.lot.to_1b': 'до 1 млрд',
  'tender.bidWaitlistForm.lot.to_10b': 'до 10 млрд',
  'tender.bidWaitlistForm.lot.over_10b': 'больше 10 млрд',
  'tender.bidWaitlistForm.agree': 'Условия понятны, мне это интересно',
  'tender.bidWaitlistForm.termsMissing': 'Отметьте «Условия понятны», чтобы встать в очередь',
  'tender.bidWaitlistForm.submit': 'Встать в очередь',
  'tender.bidWaitlistForm.footnote':
    'Сейчас это ни к чему не обязывает. Ответы учтём, когда будем открывать доступ.',
  'tender.bidWaitlistForm.doneTelegram': 'Мы напишем в Telegram, когда откроем доступ',
  'tender.bidWaitlistForm.doneEmail': 'Мы напишем на почту, когда откроем доступ',
  'tender.bidWaitlistForm.doneOk': 'Понятно',

  // ── «Данные компании для заявок». Как и весь блок пакета заявки выше, на
  // KZ-развёртывании пока по-русски: фича закрыта грантом и там не раздаётся.
  'bidProfile.title': 'Данные компании для заявок',
  'bidProfile.lead':
    'Подписант, контакты, реквизиты, лицензии, опыт и техника — их подставляет каждый пакет заявки. Заполните один раз: по конкретному лоту спросим только то, чего здесь не хватает.',
  'bidProfile.completeness': 'Заполнено {{filled}} из {{total}}',
  'bidProfile.save': 'Сохранить',
  'bidProfile.saving': 'Сохраняем…',
  'bidProfile.saved': 'Сохранили.',
  'bidProfile.saveError': 'Не удалось сохранить. Попробуйте ещё раз.',
  'bidProfile.loadError': 'Не удалось загрузить данные компании.',
  'bidProfile.skipHint':
    'Любое поле можно оставить пустым — в документе на его месте будет видимый пропуск, который вы заполните сами.',

  'tender.gate.title': 'Құжаттар мен тапсырыс берушінің байланыстары жасырын',
  'tender.gate.lockedContacts': 'Тапсырыс берушінің байланыстары',
  'tender.gate.lockedWinnerContacts': 'Өткен тендер жеңімпаздарының байланыстары',
  'tender.gate.lockedDocs': 'Тендерлік құжаттама',
  'tender.gate.lockedSummary': 'ТТ толық талдауы',
  'tender.gate.lockedAnalytics': 'Нарық пен тапсырыс беруші бойынша аналитика',
  'tender.gate.guest':
    'Тегін тіркеліңіз — сақталған іздеулер және поштаға немесе Telegram-ға хабарламалар',
  'tender.gate.free':
    'Pro рәсімдеңіз — тапсырыс берушінің байланыстары, құжаттар және нарық аналитикасы',
  'tender.cta.register': 'Тіркелу',
  'tender.cta.pro': 'Pro тарифін іске қосу',
  'tender.cta.contacts': 'Байланыстарды ашу',
  'freeUnlock.title': 'Тендерді тегін ашу',
  'freeUnlock.buttonFree': 'Pro тарифінің деректерін тегін ашу',
  'freeUnlock.remaining': 'Қалған тегін ашулар: {{n}}',
  'freeUnlock.pending': 'Ашылуда…',
  'freeUnlock.error': 'Тендерді ашу мүмкін болмады. Қайталап көріңіз.',
  'freeUnlock.spent': 'Тегін ашу қолданылды — Pro рәсімдеу',
  'freeUnlock.needTin': 'Компанияның БСН/ЖСН қосыңыз',
  'freeUnlock.needPhone': 'Telegram-да телефонды растаңыз',
  'freeUnlock.phoneTaken': 'Бұл нөмір басқа тіркелгіде қолданылған',
  'freeUnlock.completeProfile': 'Профильді толтыру',
  'freeUnlock.confirmPhone': 'Телефонды растау',
  'freeUnlock.orPro': 'немесе Pro рәсімдеу',
  'dashboard.greeting': 'Қайта оралуыңызбен',
  'dashboard.nudge.title': 'Санат қосыңыз — хабарландыру алыңыз',
  'dashboard.nudge.body':
    'Каталогта санатты таңдап, оны сақтаңыз. Жаңа сәйкес тендер пайда болысымен Telegram немесе пошта арқылы хабарлама жібереміз.',
  'dashboard.nudge.cta': 'Санат қосу',
  'onboarding.title': 'Баптауды аяқтаңыз',
  'onboarding.progress': '{{total}}-дің {{done}}-і',
  'onboarding.step.telegram': 'Telegram арқылы кіру',
  'onboarding.step.telegramHint': 'Хабарландыру алу үшін төменде Telegram қосыңыз.',
  'onboarding.step.search': 'Кемінде бір іздеуді сақтаңыз',
  'onboarding.step.inn': 'Компанияның БСН/ЖСН көрсетіңіз',
  'onboarding.step.innHint':
    'Компанияңыз қанша тендер жеңгенін көрсетеміз. Форма осы беттің төменінде.',
  'onboarding.step.searchCta': 'Қосу',
  'ikpu.picker.placeholder': 'Тауар атауы немесе коды бойынша іздеу…',
  'ikpu.picker.searching': 'Ізделуде…',
  'ikpu.picker.noResults': 'Ештеңе табылмады',
  'ikpu.picker.remove': 'Алып тастау',
  'ikpu.picker.activeCount': '{{count}} белсенді',
  'ikpu.picker.hint': '{{max}} нишаға дейін таңдаңыз',
  'ikpu.picker.max': 'Ең көбі таңдалды ({{max}}). Басқасын қосу үшін нишаны алып тастаңыз.',
  'onboarding.niche.title': 'Ниша таңдаңыз',
  'onboarding.niche.desc':
    'Бұл ниша бойынша әр жаңа сәйкес тендерді поштаңызға немесе Telegram-ға жібереміз.',
  'onboarding.niche.save': 'Хабарламаларды қосу',
  'onboarding.niche.saving': 'Сақталуда…',
  'onboarding.niche.saveNetworkError':
    'Сақтау мүмкін болмады — байланысты тексеріңіз. Біз қайталап көрдік, бірақ байланыс үзілді.',
  'onboarding.niche.saveError': 'Нишаны сақтау мүмкін болмады. Қайталап көріңіз.',
  'onboarding.done.intro': 'Дайын! Хабарламалар қосылды.',
  'onboarding.done.sent': 'Бірінші тендер Telegram-ға жіберілді',
  'onboarding.done.sentDesc': 'Әрі қарай әр жаңа сәйкес тендер автоматты түрде келеді.',
  'onboarding.done.empty': 'Қазір бұл нишада белсенді тендерлер жоқ.',
  'onboarding.done.emptyAdjacent': 'Пайда болысымен жібереміз. Белсенді лоттары бар ұқсас нишалар:',
  'onboarding.done.close': 'Дайын',
  'onboarding.modal.title': '{{brand}} сайтына қош келдіңіз!',
  'onboarding.modal.intro': 'Сәйкес тендерлерді жіберіп алмау үшін хабарландыруларды баптаңыз.',
  'onboarding.modal.tgTitle': 'Telegram қосыңыз',
  'onboarding.modal.tgDesc': 'Жаңа тендерлер туралы хабарландыруларды тікелей Telegram-да алыңыз.',
  'onboarding.modal.searchTitle': 'Санат қосыңыз',
  'onboarding.modal.searchDesc':
    'Санатты таңдап, іздеуді сақтаңыз — жаңа сәйкес тендерлер туралы хабарлама жібереміз.',
  'onboarding.modal.searchCta': 'Санат таңдау',
  'onboarding.modal.later': 'Кейінірек',
  'onboarding.modal.close': 'Жабу',
  'onboarding.categories.title': 'Санат таңдаңыз',
  'onboarding.categories.desc':
    'Таңдалған ниша бойынша жаңа тендерлер мен поштаға немесе Telegram-ға хабарламалар.',
  'onboarding.categories.searchToggle': 'Таппадыңыз ба? Іздеу →',
  'onboarding.categories.search': 'Санат іздеу…',
  'onboarding.categories.searchNoResults': 'Ештеңе табылмады',
  'onboarding.categories.searching': 'Ізделуде…',
  'onboarding.categories.popular': 'Танымал',
  'onboarding.ikpu.label': 'Немесе тауар коды бойынша',
  'onboarding.ikpu.hint': 'Теруді бастаңыз — кез келген сұрау бойынша нақты нишаларды көрсетеміз',
  'onboarding.categories.section': 'Санаттар',
  'onboarding.ikpu.section': 'Нақты нишалар',
  'onboarding.categories.more': 'Тағы {{count}} санат',
  'onboarding.saved': 'Сақталды — нишаңыздағы жаңа тендерлер туралы хабарландырулар қосылды.',
  'onboarding.stepOf': '{{total}}-дің {{n}}-қадамы',
  'onboarding.back': '← Артқа',
  'onboarding.tg.cta': 'Жаңа тендерлер туралы бірінші біліңіз',
  'onboarding.tg.connectedDone': 'Telegram қосылды — бәрі дайын.',
  'onboarding.sample.bot': '{{brand}} боты',
  'onboarding.sample.title': 'Нишаңыз бойынша жаңа тендер',
  'onboarding.sample.tender': '«Мемлекеттік мекемеге тауарлар жеткізу»',
  'onboarding.sample.tender.construction': '«Мектеп ғимаратын күрделі жөндеу»',
  'onboarding.sample.tender.automotive': '«Мекеме қажеттіліктеріне автомобильдер жеткізу»',
  'onboarding.sample.tender.food': '«Балабақшаға азық-түлік жеткізу»',
  'onboarding.sample.tender.consulting': '«Құрылысқа техникалық қадағалау қызметтері»',
  'onboarding.sample.tender.events-culture': '«Салтанатты іс-шараны ұйымдастыру және өткізу»',
  'onboarding.sample.tender.electrical': '«Трансформаторлық қосалқы станцияны жеткізу және орнату»',
  'onboarding.sample.tender.machinery': '«Сорғы жабдығын жеткізу»',
  'onboarding.sample.tender.water-environmental': '«Сумен жабдықтау желілерін реконструкциялау»',
  'onboarding.sample.tender.energy-fuel': '«Дизель отынын жеткізу»',
  'onboarding.sample.tender.transport-logistics': '«Жүк тасымалдау қызметтері»',
  'onboarding.sample.tender.financial-legal': '«Қаржылық есептілікті аудиттеу қызметтері»',
  'onboarding.sample.tender.agriculture': '«Минералды тыңайтқыштарды жеткізу»',
  'onboarding.sample.tender.chemicals': '«Бояу-лак материалдарын жеткізу»',
  'onboarding.sample.tender.office-supplies': '«Кеңсе тауарларын жеткізу»',
  'onboarding.sample.tender.printing-publishing': '«Оқу құралдарын басып шығару қызметтері»',
  'onboarding.sample.tender.cleaning-sanitation': '«Әкімшілік ғимараттарды тазалау қызметтері»',
  'onboarding.sample.meta': '💰 2 400 000 000 {{currency}} · ⏰ 12 күн қалды',
  'onboarding.sample.budget': '💰 {{amount}} {{currency}}',
  'onboarding.sample.daysLeft': '⏰ {{n}} {{word}} қалды',
  'alerts.unconfirmed': 'Пошта расталмаған — бір ғана іріктеме келеді.',
  'alerts.unconfirmed.cta': 'Поштаны растау',
  'dashboard.alerts.searchesCount': 'Сақталған іздеулер: {{count}}.',
  'emailConfirm.ok': 'Пошта расталды — іріктемелер осы мекенжайға келеді.',
  'emailConfirm.expired': 'Сілтеменің мерзімі өтті. Поштаны кодпен растаңыз.',
  'emailConfirm.invalid': 'Сілтеме жұмыс істемеді. Поштаны кодпен растаңыз.',
  'emailConfirm.signIn':
    'Сайтқа кіріңіз — поштаны каталог үстіндегі «Поштаны растау» жолында растауға болады.',
  'emailConfirm.close': 'Жабу',
  'onboarding.categories.pickPrompt': 'Жалғастыру үшін санат таңдаңыз',
  'onboarding.cta.connect': '«{{category}}» санатын Telegram-да алу',
  'onboarding.cta.finish': 'Дайын',
  'catalog.nudge.compact':
    'Санатты таңдап сақтаңыз — жаңа тендерлер поштаңызға немесе Telegram-ға келеді.',
  'dashboard.alerts': 'Хабарландырулар',
  'dashboard.alerts.empty': 'Хабарландырулар бапталмаған.',
  'dashboard.alerts.active': 'Белсенді: {{count}} — жаңа сәйкес тендерлер Telegram-ға келеді.',
  'dashboard.alerts.activeEmail': 'Белсенді: {{count}} — жаңа сәйкес тендерлер поштаға келеді.',
  'dashboard.alerts.activeBoth':
    'Белсенді: {{count}} — жаңа сәйкес тендерлер Telegram-ға және поштаға келеді.',
  'dashboard.alerts.allChannelsOff':
    'Сақталған іздеулер: {{count}}, бірақ барлық хабарландыру арналары өшірілген — сіз ештеңе алмайсыз.',
  'dashboard.alerts.connectTg': 'Хабарландыру алу үшін жоғарыда Telegram қосыңыз.',
  'dashboard.alerts.noSearches':
    'Нишаңыздағы жаңа тендерлер туралы хабарландыру алу үшін іздеуді сақтаңыз.',
  'dashboard.notifications': 'Жаңа тендерлер туралы хабарландырулар',
  'dashboard.notifications.hint':
    'Сәйкес тендерлер туралы хабарландырулар Telegram-ға немесе поштаңызға келеді. Барлық хабарландыруларды тоқтату үшін өшіріңіз.',
  'dashboard.notifications.email': 'Email-хабарландырулар',
  'dashboard.notifications.email.hint': 'Сәйкес тендерлер поштаңызға келеді.',
  'dashboard.notifications.telegram': 'Telegram-хабарландырулар',
  'dashboard.notifications.telegram.hint': 'Сәйкес тендерлер Telegram-ға келеді.',
  'dashboard.notifications.telegram.connectFirst': 'Жоғарыда Telegram қосыңыз',
  'dashboard.plan': 'Сіздің тарифіңіз',
  'dashboard.plan.free': 'Тегін тариф — байланыстар мен экспортты ашу үшін өтіңіз.',
  'dashboard.plan.active': '{{plan}} тарифі белсенді — {{date}} дейін жарамды.',
  'dashboard.plan.manage': 'Жазылымды басқару',
  'dashboard.plan.autoRenewOn': 'Автожаңарту қосулы',
  'dashboard.plan.autoRenewOff': 'Автожаңарту өшірулі',
  'dashboard.matches.week': 'Сақталған іздеулеріңіз 7 күнде {{count}} жаңа тендер тапты.',
  'dashboard.matches.none': 'Соңғы 7 күнде сақталған іздеулеріңіз бойынша жаңа сәйкестіктер жоқ.',
  'support.trigger': 'Көмек және қолдау',
  'support.title': 'Көмек және қолдау',
  'support.desc': 'Мәселені немесе идеяны сипаттаңыз — сізбен email арқылы байланысамыз.',
  'support.dashboard.desc': 'Сұрағыңыз немесе тілегіңіз бар ма? Бізге жазыңыз — көмектесеміз.',
  'support.emailPrefix': 'Бізге поштаға жазыңыз:',
  'support.telegramPrefix': 'Немесе бізге Telegram-да жазыңыз:',
  'support.phonePrefix': 'Немесе қоңырау шалыңыз:',
  'support.categoryLabel': 'Санат',
  'support.category.improvement': 'Жақсарту',
  'support.category.bug': 'Жүйе қатесі',
  'support.category.subscription': 'Жазылым',
  'support.category.notification': 'Хабарландыру мәселесі',
  'support.category.other': 'Басқа',
  'support.messageLabel': 'Хабарлама',
  'support.messagePlaceholder': 'Не болғанын немесе нені жақсартуға болатынын айтыңыз…',
  'support.emailLabel': 'Жауап алуға email',
  'support.submit': 'Жіберу',
  'support.sending': 'Жіберілуде…',
  'support.success': 'Рақмет! Сізбен байланысамыз.',
  'support.done': 'Дайын',
  'support.error': 'Жіберу мүмкін болмады. Қайталап көріңіз.',
  'support.invalid':
    'Санатты таңдаңыз, хабарлама енгізіңіз (кемінде 5 таңба) және дұрыс email көрсетіңіз.',
  'support.close': 'Жабу',
  'billing.return.pageTitle': 'Төлем алынды',
  'billing.return.title': 'Төлеміңіз үшін рақмет!',
  'billing.return.body':
    'Төлем алынды және өңделуде. Тарифіңіз бірнеше минут ішінде автоматты түрде іске қосылады.',
  'billing.return.bodyActive': 'Төлем сәтті өтті — қолжетімділік бұрыннан ашық.',
  'billing.return.planActive': '{{plan}} тарифі белсенді',
  'billing.return.paidUntil': 'Қолжетімділік {{date}} дейін ашық',
  'billing.return.nextCharge': 'Автожаңарту қосулы · келесі есептен шығару {{date}}',
  'billing.return.noteActive':
    'Жазылым мен төлем мәліметтері — жеке кабинетте. Сұрақтарыңыз болса, {{brandEmail}} мекенжайына жазыңыз.',
  'billing.return.attachTitle': 'Автожаңартуды қосыңыз',
  'billing.return.attachBody':
    'Қолжетімділік {{date}} аяқталады. Картаны байланыстырыңыз — жазылым қайта төлемсіз өздігінен жаңарады.',
  'billing.return.attachCta': 'Картаны байланыстыру',
  'billing.return.orderRef': 'Тапсырыс нөмірі',
  'billing.return.ctaCatalog': 'Тендерлерге өту',
  'billing.return.ctaTender': 'Тендерге оралу',
  'billing.return.ctaDashboard': 'Жеке кабинетке',
  'billing.return.note':
    'Тариф бірнеше минуттан кейін іске қосылмаса, {{brandEmail}} мекенжайына жазыңыз — көмектесеміз.',
  // ── Billing return: төлем ҚАБЫЛДАНБАДЫ ─────────────────────────
  // Шлюз қайтару сілтемесінде айтқанда (`octo_status=canceled`, Click-тің
  // теріс `payment_status`-ы) немесе тапсырыс `cancelled` болғанда шығады.
  'billing.return.failedPageTitle': 'Төлем өтпеді',
  'billing.return.failedTitle': 'Төлем өтпеді',
  'billing.return.failedBody':
    'Банк төлемді қабылдамады немесе төлем тоқтатылды — жазылым іске қосылмады. Қайталап көруге болады: сол картамен немесе басқа картамен.',
  'billing.return.failedReasonFunds': 'Картада қаражат жеткіліксіз.',
  'billing.return.failedReasonCard': 'Банк карта деректерін қабылдамады.',
  'billing.return.failedReason3ds': '3-D Secure растауы өтпеді.',
  'billing.return.failedReasonExpired': 'Картаның жарамдылық мерзімі аяқталған.',
  'billing.return.failedRetry': 'Қайталап көру',
  'billing.return.failedNote':
    'Егер ақша бәрібір есептен шығарылса — {{brandEmail}} мекенжайына жазыңыз, тексереміз.',
  // Spain only (`features.neutralBillingReturn`); kept for key parity.
  'billing.return.noPaymentTitle': 'Төлем алынбады',
  'billing.return.noPaymentBody':
    'Егер төлеген болсаңыз, ол бірнеше минутта түседі; әйтпесе тарифтерге оралыңыз.',
  'billing.return.noPaymentCta': 'Тарифтерге оралу',
  'team.pageTitle': 'Команда',
  'team.subtitle': 'Бір жазылым бойынша қызметкерлерге Pro қолжетімділігі.',
  'team.seats': 'Алынған орындар: {{limit}}-дің {{used}}-і',
  'team.role.owner': 'Иесі',
  'team.role.member': 'Қызметкер',
  'team.joined': 'Командада бері',
  'team.rename': 'Атын өзгерту',
  'team.renameLabel': 'Команда атауы',
  'team.renameSave': 'Сақтау',
  'team.renameCancel': 'Бас тарту',
  'team.invite': 'Шақыру',
  'team.inviteTitle': 'Шақыру сілтемесі',
  'team.inviteHint':
    'Бұл сілтемені қызметкерге жіберіңіз — мысалы Telegram-да. Ол бір реттік және 7 күн жарамды.',
  'team.inviteCopy': 'Көшіру',
  'team.inviteCopied': 'Көшірілді',
  'team.inviteClose': 'Жабу',
  'team.remove': 'Жою',
  'team.removeConfirm':
    'Қызметкерді командадан жою керек пе? Ол Pro қолжетімділігін бірден жоғалтады.',
  'team.invitesTitle': 'Қолданылмаған шақырулар',
  'team.inviteExpires': '{{date}} дейін жарамды',
  'team.inviteOutstanding': 'Сілтеме белсенді',
  'team.revoke': 'Кері қайтару',
  'team.revokeConfirm':
    'Шақыруды кері қайтару керек пе? Сілтеме бірден жұмыс істемей қалады — ол арқылы командаға кіру мүмкін болмайды.',
  'team.leave': 'Командадан шығу',
  'team.leaveConfirm':
    'Командадан шығу керек пе? Команда жазылымы бойынша Pro қолжетімділігін бірден жоғалтасыз. Қайта оралу тек жаңа шақыру бойынша мүмкін болады.',
  'team.disband': 'Команданы тарату',
  'team.disbandConfirm':
    'Команданы тарату керек пе? Командада {{count}} қызметкер бар — олардың барлығы Pro қолжетімділігін бірден жоғалтады, ал қолданылмаған шақырулар жұмыс істемей қалады. Әрекет қайтымсыз.',
  'team.noSeats': 'Барлық орындар алынған. Тағы шақыру үшін орын босатыңыз.',
  'team.tooManyInvites':
    'Қолданылмаған шақыру сілтемелері тым көп. Жаңасын жасау үшін жоғарыдағы тізімнен бірін кері қайтарыңыз.',
  'team.create': 'Команда жасау',
  'team.emptyTitle': 'Командалық қолжетімділік',
  'team.emptyBody': '«Бизнес» тарифі 3 орын береді: сіз және екі қызметкер.',
  'team.planRequired': 'Командалық қолжетімділік «Бизнес» тарифінде қолжетімді.',
  'team.viaBadge': '«{{name}}» командасынан қолжетімділік',
  'team.error': 'Команданы жүктеу мүмкін болмады. Кейінірек қайталап көріңіз.',
  'team.genericError': 'Әрекетті орындау мүмкін болмады. Қайталап көріңіз.',
  'join.title': 'Командаға шақыру',
  'join.signedOut': 'Шақыруды қабылдау үшін кіріңіз немесе тіркеліңіз.',
  'join.accept': 'Шақыруды қабылдау',
  'join.accepting': 'Қабылдануда…',
  'join.success': 'Дайын! Сіз «{{name}}» командасындасыз.',
  'join.goToTeam': 'Командаға өту',
  'join.ownSubscription':
    'Сізде {{date}} дейін өз жазылымыңыз бар. Ол негізгі болып қалады — командадағы орын оның мерзімі аяқталған соң іске қосылады.',
  'join.ownSubscriptionNoDate':
    'Сізде өз жазылымыңыз бар. Ол негізгі болып қалады — командадағы орын оның мерзімі аяқталған соң іске қосылады.',
  // Шақыру туралы мәлімет — түймеден БҰРЫН (GET /teams/invitations/:token).
  'join.alreadyMember': 'Сіз «{{name}}» командасында бұрыннан барсыз.',
  'join.invitedBy': 'Шақырған: {{name}}',
  'join.teamPlan':
    'Команда тарифі: {{plan}} — тапсырыс берушілердің байланыстары, құжаттама және талдау ашылады',
  'join.expiresAt': 'Сілтеме {{date}} дейін жарамды',
  'join.error.invite_not_found': 'Сілтеме жарамсыз.',
  'join.error.invite_expired': 'Сілтеменің мерзімі өтті. Жаңасын сұраңыз.',
  'join.error.invite_used': 'Сілтеме бұрыннан қолданылған.',
  'join.error.invite_revoked': 'Шақыру кері қайтарылды.',
  'join.error.no_seats': 'Командада бос орын қалмады.',
  'join.error.already_in_team':
    'Сіз бұрыннан командадасыз. Қызметкер «Команда» бетінде одан шыға алады, ал иесі сол жерде өз командасын тарата алады. Осыдан кейін шақыруды қайта ашыңыз.',
  'join.error.generic': 'Шақыруды қабылдау мүмкін болмады. Кейінірек қайталап көріңіз.',
  'notFound.title': 'Бет табылмады',
  'notFound.body':
    'Мүмкін, мекенжайда қате бар немесе бет енді жоқ — мысалы, тендер жарияланымнан алынып тасталды.',
  'notFound.action': 'Каталогқа оралу',
  'routeError.badge': 'Қате',
  'routeError.title': 'Бет ашылмады',
  'routeError.body':
    'Жүктеу кезінде бірдеңе дұрыс болмады. Бетті жаңартыңыз немесе каталогқа оралыңыз.',
  'catalog.kind.all': 'Барлығы',
  'catalog.kind.goods': 'Тауарлар',
  'catalog.kind.works': 'Жұмыстар',
  'catalog.kind.services': 'Қызметтер',
  'catalog.kind.aria': 'Сатып алу түрі',
  'catalog.kind.ariaLabel': '{{label}}, {{count}} тендер',
  'company.title': 'Ұйымыңыздың атауы немесе БСН/ЖСН?',
  'company.subtitle':
    'Компанияңыз бұрын не жеңгенін немесе саласыңызда қазір қанша тендер ашық екенін көрсетеміз.',
  'company.benefit.wins': 'Компанияңыз қанша тендер жеңгенін көрсетеміз',
  'company.benefit.alerts':
    'Жеңістер болса — сіз бұрын жеткізген нәрсе бойынша хабарландыруларды сүзгі баптаусыз қосамыз',
  'company.benefit.plan': 'Аймағыңыз бен саланыздың тендерлерін жіберіп алмауға көмектесеміз',
  'company.card.change': 'Өзгерту',
  'company.card.activity': 'Қызметі:',
  'company.card.status': 'Мәртебесі:',
  'company.card.region': 'Аймағы:',
  'company.card.unknownName': 'Компания анықталмады',
  'company.card.noTin': '{{tin}} көрсетілмеген',
  'company.card.notFound':
    'Тізілімнен мұндай БСН/ЖСН-мен компания таппадық. Нөмірді тексеріңіз — немесе ЖК болсаңыз, солай қалдырыңыз: компаниялар тізілімі оларды қайтармайды.',
  'company.savedTitle': 'БСН/ЖСН сақталды',
  'company.done': 'Дайын',
  'settings.title': 'Баптаулар',
  'settings.section.company': 'Компания',
  'settings.section.notifications': 'Хабарландырулар',
  'settings.section.subscription': 'Жазылым',
  'settings.section.account': 'Тіркелгі',
  'settings.summary.company': 'Компания',
  'settings.summary.noCompany': 'БСН/ЖСН көрсетілмеген',
  'settings.summary.plan': 'Тариф',
  'settings.summary.planFree': 'Тегін',
  'settings.summary.planFreeHint': 'Тапсырыс берушілердің байланыстары жабық',
  'settings.summary.alerts': 'Хабарландырулар',
  'settings.summary.alertsOn': 'Қосулы',
  'settings.summary.alertsOff': 'Өшірулі',
  'settings.summary.alertsOffHint': 'Telegram қосылмаған',
  'settings.account.email': 'Пошта',
  'settings.account.emailMissing': 'көрсетілмеген',
  'settings.account.emailVerified': 'Расталған',
  'settings.account.support': 'Көмек және қолдау',
  // Spain only (RGPD line in Ajustes); kept for key parity.
  'settings.account.delete': 'Аккаунт пен деректерді жою үшін бізге жазыңыз:',
  // Telegram арқылы кірген аккаунтта нақты пошта жоқ — синтетикалық мекенжай
  // хат қабылдамайды. Сондықтан бұл жол поштаны ҚОСУДЫ ұсынады.
  'settings.account.attachEmail.hint':
    'Пошта көрсетілмеген — шот-фактуралар мен кіру кодтарын жіберетін жер жоқ',
  'settings.account.attachEmail.cta': 'Пошта көрсету',
  'settings.account.attachEmail.label': 'Поштаңызды енгізіңіз — растау кодын жібереміз',
  'settings.account.attachEmail.codeLabel': '{{email}} мекенжайына код жіберілді. Оны енгізіңіз:',
  'settings.account.attachEmail.send': 'Код жіберу',
  'settings.account.attachEmail.confirm': 'Растау',
  'settings.account.attachEmail.cancel': 'Бас тарту',
  'settings.account.attachEmail.done': 'Пошта байланыстырылды',
  'settings.account.attachEmail.error':
    'Кодты жіберу мүмкін болмады. Мекенжайды тексеріп, қайталап көріңіз.',
  'settings.account.attachEmail.badCode': 'Код қате немесе ескірген. Жаңасын сұраңыз.',
  'settings.account.attachEmail.alreadySet': 'Бұл аккаунтта нақты пошта бұрыннан бар.',
  'settings.account.attachEmail.mergeRefused':
    'Бұл Telegram аккаунтында жазылым бар — қолдау қызметіне жазыңыз, аккаунттарды қолмен біріктіреміз.',
  'company.tinLabel': 'БСН/ЖСН',
  'company.tinPlaceholder': '{{digits}} сан',
  'company.lookup.label': 'Ұйымыңыздың БСН/ЖСН немесе атауын енгізіңіз',
  'company.lookup.placeholder': 'Атауы немесе {{digits}} сан',
  'company.lookup.searching': 'Іздеуде…',
  'company.lookup.empty': 'Табылмады — өткізіп жіберіп, кейін қосуға болады',
  'company.lookup.emptyNoSkip': 'Атауы бойынша табылмады — БСН/ЖСН енгізіңіз',
  'company.lookup.tinValue': 'БСН/ЖСН {{value}}',
  'company.lookup.wins.one': '2 жылда {{n}} жеңіс',
  'company.lookup.wins.few': '2 жылда {{n}} жеңіс',
  'company.lookup.wins.many': '2 жылда {{n}} жеңіс',
  'company.submit': 'Жалғастыру',
  'company.checking': 'Тексерілуде…',
  'company.later': 'Кейінірек',
  'company.saved': 'БСН/ЖСН сақталды.',
  'company.foundWins': 'Компанияңыз жеңген {{n}} {{word}} таптық',
  'company.foundSector': 'Саласыңызда қазір {{n}} {{word}} ашық',
  'company.foundRegion': 'Аймағыңызда қазір {{n}} {{word}} ашық',
  'company.savedName': 'Компания атауын сақтадық: «{{name}}»',
  'company.savedWithName': '{{tin}} «{{name}}» атауымен сақталды.',
  'company.foundAwards': 'Компанияңыз {{what}} жеңді{{sector}}.',
  'company.foundAwards.sector': ', көбінесе «{{name}}» бөлімінде',
  'company.foundAwards.open': 'Қазір бұл бөлімде {{count}} {{word}} ашық.',
  'company.error.invalidTin': 'БСН немесе ЖСН {{digits}} санын енгізіңіз',
  // Spain only (an id with letters, full length, refused); kept for key parity.
  'company.error.invalidControl': 'Нөмірді тексеріңіз: бақылау белгісі сәйкес келмейді',
  'company.error.changeLimit': 'БСН/ЖСН бүгін тым жиі өзгертілді. Ертең қайталап көріңіз.',
  'company.error.generic': 'Сақтау мүмкін болмады. Қайталап көріңіз.',
  'claim.card.title': 'Жеткізуші профилі',
  'claim.card.subtitle':
    'Сәйкес тендерлер жинағын алу үшін компания профилін тіркелгіңізге байланыстырыңыз.',
  'claim.card.cta': 'Компания профилін байланыстыру',
  'claim.card.needsTin': 'Алдымен жоғарыдағы бөлімде компанияның БСН/ЖСН көрсетіңіз.',
  'claim.preview.wins':
    'Бұл компания жеңген {{n}} {{word}} таптық. Профильді байланыстырып, жаңа сәйкес тендерлер туралы хабарландыру алғыңыз келе ме?',
  'claim.preview.none':
    'Жеңістер тарихы әзірге жоқ, бірақ профильді байланыстырып, жаңа тендерлер жинағын алуға болады.',
  'claim.preview.confirm': 'Иә, байланыстыру',
  'claim.preview.cancel': 'Бас тарту',
  'claim.linked.title': 'Профиль байланыстырылды',
  'claim.linked.wins': 'Жеңістер тарихында {{n}} {{word}}',
  'claim.linked.note': 'Сәйкес тендерлер туралы хабарландырулар қосылды.',
  'claim.conflict.title': 'Бұл БСН/ЖСН басқа тіркелгіге байланыстырылған',
  'claim.conflict.body':
    'Егер бұл сіздің компанияңыз болса және сол тіркелгіге қолжетімділікті жоғалтқан болсаңыз, қолдау қызметіне жазыңыз — түсінуге көмектесеміз.',
  'claim.error': 'Әрекетті орындау мүмкін болмады. Қайталап көріңіз.',
  'claim.retry': 'Қайталау',
  'phone.title': 'Телефоныңызды қалдырыңыз',
  'phone.subtitle':
    'Жазылым бойынша сұрақтар туындаса хабарласамыз. Жарнамалық қоңыраулар болмайды.',
  'phone.label': 'Телефон',
  'phone.save': 'Сақтау',
  'phone.saving': 'Сақталуда…',
  'phone.thanks': 'Рақмет — телефон сақталды.',
  'watch.follow': 'Компанияны қадағалау',
  'watch.following': 'Сіз қадағалап тұрсыз',
  'watch.hintWinner': 'Бұл компания жаңа келісімшарт жеңгенде жинаққа қосамыз.',
  'watch.hintBuyer': 'Бұл тапсырыс беруші жаңа келісімшарт орналастырғанда жинаққа қосамыз.',
  'watch.proRequired': 'Компанияларды қадағалау Pro тарифінде қолжетімді.',
  'watch.limitReached':
    'Лимитке жетті — 50 ұйым. Жаңасын қосу үшін біреуінен жазылымды тоқтатыңыз.',
  'watch.list.title': 'Қадағаланатын компаниялар',
  'watch.list.hint': 'Осы ұйымдардың жаңа келісімшарттары мен тендерлері жинағыңызға келеді.',
  'watch.list.empty':
    'Әзірге ештеңе жоқ. Тапсырыс беруші немесе жеткізуші бетінде «Компанияны қадағалау» басыңыз.',
  'watch.list.unfollow': 'Жазылымды тоқтату',
  'watch.list.kindBuyer': 'тапсырыс беруші',
  'watch.list.kindWinner': 'жеткізуші',
  'saved.categoriesLabel': 'Жазылым санаттары',
  'saved.categoryAdd': 'Санат, ЕНС ТРУ немесе ниша қосу',
  'saved.categoryRemove': 'Санатты алып тастау',
  'saved.ikpuLabel': 'Жазылымның ЕНС ТРУ кодтары',
  'saved.ikpuRemove': 'ЕНС ТРУ кодын алып тастау',
  'saved.nicheLabel': 'Жазылым нишалары',
  'saved.nicheRemove': 'Нишаны алып тастау',
  'saved.regionLabel': 'Аймақтар',
  'saved.kindLabel': 'Сатып алу түрі',
  'saved.textLabel': 'Сипаттамадағы сөздер',
  'saved.textPlaceholder': 'сорғы',
  'saved.textHint': 'Осы сөздердің біреуі жеткілікті.',
  'saved.textHintCodes':
    'Кодтар таңдалғанда сөздер жазылымды тарылтпайды: осы кодтардың барлық лоттары келеді.',
  'saved.anyRegion': 'Барлық аймақтар',
  'saved.includeSupplyLabel': 'Ұсыныс сұрауларын да жіберу',
  'saved.includeSupplyHint': 'Осы сүзгі бойынша жарияланған бюджетсіз өтінімдер.',
  'saved.customerLabel': 'Тапсырыс беруші',
  'saved.customerPlaceholder': 'Ұйым атауы',
  'saved.customerHint': 'Хабарландырулар тек осы тапсырыс берушінің тендерлері бойынша келеді.',
  'saved.customerRemove': 'Тапсырыс берушіні алып тастау',
  // ── «Компьютерден төлеу» (XDEV-LINK, 2026-09-26) ─────────────────
  'plans.payFromDesktop': 'Компьютерден төлеу',
  'plans.payFromDesktopSending': 'Сілтеме жіберілуде…',
  'plans.payLinkSentTelegram': 'Сілтеме Telegram-ға жіберілді, 24 сағат жарамды',
  'plans.payLinkSentEmail': 'Сілтеме поштаға жіберілді, 24 сағат жарамды',
  'plans.payLinkNoChannel': 'Сілтемені жіберетін жер жоқ — профильде поштаны қосыңыз',
  'plans.payLinkNoChannelCta': 'Пошта қосу',
  'plans.payLinkError': 'Сілтемені жіберу мүмкін болмады. Қайталап көріңіз',
  // «Оплата по телефону» — только UZ-сборка (Click/Payme), поэтому по-русски
  'plans.sms.hint':
    'В браузере {{app}} оплата картой не проходит. Выставим счёт на ваш номер от ООО «FASTAGO» — оплатите его в приложении {{apps}} за минуту',
  'plans.sms.or': ' или ',
  'plans.sms.phoneLabel': 'Номер телефона',
  'plans.sms.pickGateway': 'В каком приложении оплатите',
  'plans.sms.send': 'Выставить счёт на мой номер',
  'plans.sms.sending': 'Выставляем счёт…',
  'plans.sms.sentTitle': '✓ Счёт выставлен на {{phone}}',
  'plans.sms.sentBody':
    'Откройте приложение {{gateway}} — там счёт на оплату от ООО «FASTAGO». Доступ включится автоматически, страницу можно закрыть',
  'plans.sms.sentPaymeSms': 'Payme также пришлёт SMS со ссылкой на оплату.',
  'plans.sms.waiting': 'Ждём оплату…',
  'plans.sms.resendPrompt': 'Счёт не появился за 2 минуты?',
  'plans.sms.resend': 'Выставить ещё раз',
  'plans.sms.resendIn': 'Выставить ещё раз через {{time}}',
  'plans.sms.switchGateway': 'Оплатить через {{gateway}}',
  'plans.sms.paidTitle': 'Оплачено — {{name}} активен',
  'plans.sms.goTenders': 'Перейти к тендерам',
  'plans.sms.fallbackHosted': 'Оплатить на странице Click или Payme',
  'plans.sms.seconds': '{{n}} с',
  'plans.sms.minutes': '{{n}} мин',
  'plans.sms.hours': '{{n}} ч',
  'plans.sms.err.invalid_phone': 'Введите номер: +998 и 9 цифр',
  'plans.sms.err.no_gateway_account':
    'Этот номер не зарегистрирован в {{gateway}}. Выберите другое приложение или номер',
  'plans.sms.err.gateway_declined': '{{gateway}} не принял запрос. Попробуйте другое приложение',
  'plans.sms.err.provider_unavailable': '{{gateway}} сейчас недоступен. Выберите другое приложение',
  'plans.sms.err.rate_limited': 'Слишком много запросов подряд. Попробуйте через {{time}}',
  'plans.sms.err.gateway_error': '{{gateway}} не ответил. Попробуйте ещё раз',
  'plans.sms.err.generic': 'Не удалось выставить счёт. Попробуйте ещё раз',

  // ── /pay/:token беті ─────────────────────────────────────────────
  'payLink.pageTitle': 'Төлем',
  'payLink.loading': 'Төлемді ашып жатырмыз…',
  'payLink.title': 'Компьютерден төлеу',
  'payLink.lead': 'Тапсырыс дайын — төлем бетіне өту үшін түймені басыңыз.',
  'payLink.cta': 'Төлемге өту',
  'payLink.onceNote': 'Сілтеме бір рет ашылады. Төлем беті осы терезеде ашылады.',
  'payLink.backToPlans': 'Тарифтерге оралу',
  'payLink.openPlans': 'Тарифтерді ашу',
  'payLink.used.title': 'Сілтеме бұрын ашылған',
  'payLink.used.body':
    'Ол бір рет қана жұмыс істейді. Егер төлем өтпесе, тарифтерді ашып, қайта бастаңыз — ақша алынған жоқ.',
  'payLink.notFound.title': 'Сілтеме жарамсыз',
  'payLink.notFound.body':
    'Жарамдылық мерзімі — 24 сағат. Тапсырыс төленген немесе тоқтатылған болуы мүмкін. Тарифтерді ашып, қайта бастаңыз.',
  // ── Сессиясыз компьютердегі түбіртек (/billing/return?pl=<токен>) ─
  'payLink.receipt.paidTitle': 'Төлем өтті',
  'payLink.receipt.paidBody': 'Қолжетім ашылды. Жұмысты бастау үшін аккаунтқа кіріңіз.',
  'payLink.receipt.pendingTitle': 'Төлем расталуын күтудеміз',
  'payLink.receipt.pendingBody':
    'Төлемді банк әлі растауда. Бір минуттан кейін бетті жаңартыңыз — немесе жай ғана аккаунтқа кіріңіз, қолжетім өзі ашылады.',
  'payLink.receipt.failedTitle': 'Төлем өтпеді',
  'payLink.receipt.failedBody': 'Ақша алынған жоқ. Қайта көруге болады.',
  'payLink.receipt.paidAt': '{{date}} төленді',
  'payLink.receipt.loginTelegram': 'Сіз Telegram арқылы кіргенсіз {{hint}}',
  'payLink.receipt.loginTelegramPlain': 'Сіз Telegram арқылы кіргенсіз',
  'payLink.receipt.loginEmail': 'Сіз пошта арқылы кіргенсіз {{hint}}',
  'payLink.receipt.loginEmailPlain': 'Сіз пошта арқылы кіргенсіз',
  'payLink.receipt.login': 'Аккаунтқа кіру',
  // ── /zayavka — Meta Lead науқанына арналған өтінім формасы (2026-10-06, v2) ──
  'zayavka.pageTitle': 'Өтінім: тауарыңызға сай тендерлерді табамыз',
  'zayavka.metaDescription': 'Үш қадам — және салаңыз бойынша ашық сатып алуларды табамыз.',
  'zayavka.progress': '{{n}} / {{total}}',
  'zayavka.back': '← Артқа',
  'zayavka.next': 'Әрі қарай',
  'zayavka.s1.title': 'Не жеткізесіз?',
  'zayavka.s1.search': 'Тауар, қызмет немесе код',
  'zayavka.s1.keyword': '«{{q}}» бойынша іздеу',
  'zayavka.s1.loading': 'Ашық лоттарды санап жатырмыз…',
  'zayavka.s1.summary': '{{count}} {{lots}}, барлығы {{sum}} {{currency}}',
  'zayavka.s1.summaryNoSum': '{{count}} {{lots}}',
  'zayavka.s1.none': 'Қазір ашық лот жоқ',
  'zayavka.lots.one': 'ашық лот',
  'zayavka.lots.few': 'ашық лот',
  'zayavka.lots.many': 'ашық лот',
  'zayavka.lot.until': '{{date}} дейін',
  'zayavka.lot.noBudget': 'Бюджет көрсетілмеген',
  'zayavka.lot.announced': 'Жақында өтінімдер қабылданады',
  'zayavka.s2.title': 'Сіз туралы',
  'zayavka.q.experience': 'Тендерлерге қатыстыңыз ба?',
  'zayavka.q.experience.won_this_year': 'Биыл жеңдім',
  'zayavka.q.experience.won_last_year': 'Былтыр жеңдім',
  'zayavka.q.experience.participated': 'Қатыстым, жеңбедім',
  'zayavka.q.experience.never': 'Қатыспадым',
  'zayavka.q.esign': 'ЭЦҚ бар ма?',
  'zayavka.q.esign.yes': 'Иә',
  'zayavka.q.esign.no': 'Жоқ',
  'zayavka.q.form': 'Компания нысаны',
  'zayavka.q.form.legal': 'Заңды тұлға (ЖШС, АҚ…)',
  'zayavka.q.form.ip': 'ЖК',
  'zayavka.q.form.self_employed': 'Өзін-өзі жұмыспен қамтыған',
  'zayavka.q.form.individual': 'Жеке тұлға',
  'zayavka.q.budget': 'Қандай тендер бюджеті сізге сай?',
  'zayavka.q.budget.lt_100m': '100 млн-ға дейін',
  'zayavka.q.budget.100m_1b': '100 млн – 1 млрд',
  'zayavka.q.budget.1b_10b': '1–10 млрд',
  'zayavka.q.budget.gt_10b': '10 млрд-тан жоғары',
  'zayavka.s3.title': 'Сізбен қалай байланысамыз',
  'zayavka.id.label': 'СТН немесе ЖСН',
  'zayavka.id.invalid': 'СТН — 9 цифр, ЖСН — 14',
  'zayavka.phone.label': 'Телефон',
  'zayavka.phone.country': 'Ел коды',
  'zayavka.phone.invalid': 'Нөмірді тексеріңіз',
  'zayavka.submit': 'Жіберу',
  'zayavka.submitting': 'Жіберілуде…',
  'zayavka.consent': 'Басу арқылы қоңырауға немесе Telegram-дағы хабарламаға келісесіз',
  'zayavka.error.network': 'Байланыс жоқ — қайта басыңыз',
  'zayavka.error.rateLimited': 'Бұл желіден өтінім көп. Бізге жазыңыз:',
  'zayavka.error.generic': 'Жіберу мүмкін болмады. Бізге жазыңыз:',
  'zayavka.thanks.title': 'Өтініміңізге рақмет',
  'zayavka.thanks.body': 'Профиліңізді қарап, хабарласамыз — әдетте жұмыс күні ішінде',
  'zayavka.thanks.register': 'Тегін тіркелу',

  // ── ИИ-онбординг — Kazakhstan only, on for everyone (owner, 2026-10-15) ──
  // Экран 1: описание своими словами или БИН. Экран 2: предложение
  // редактируемыми чипами. Остальное — пять состояний отказа (макет 5).
  // Машинный перевод, как и остальной kk-каталог, — ждёт вычитки носителем.
  'aiOnboarding.step1.title': 'Не жеткізесіз?',
  'aiOnboarding.step1.desc':
    'Өз сөзіңізбен сипаттаңыз. Хабарландыруларға кодтарды, тауашаларды және сөздерді таңдап береміз.',
  'aiOnboarding.step1.placeholder': 'сорғылар және оларға қосалқы бөлшектер, электр қозғалтқыштар',
  'aiOnboarding.step1.example':
    'Мысалы: сорғылар және оларға қосалқы бөлшектер, электр қозғалтқыштар.',
  'aiOnboarding.step1.or': 'немесе',
  'aiOnboarding.step1.tinLabel': 'Компанияның {{tin}} көрсетіңіз',
  'aiOnboarding.step1.tinHint': 'Кодтарды бұрынғы сатып алуларыңыздан аламыз.',
  'aiOnboarding.step1.submit': 'Таңдау',
  'aiOnboarding.step1.loading': 'Таңдап жатырмыз…',
  'aiOnboarding.step1.manual': 'санатты қолмен таңдау',
  // Spain only (`features.aiOnboardingReentry`); kept for key parity.
  'aiOnboarding.reentry': 'Хабарландыруларды ЖИ-мен баптау',
  // Spain only (`features.aiCompanyStep`, step 1 hints); kept for key parity.
  'aiOnboarding.step1.needWords': 'Кемінде үш сөзбен сипаттаңыз',
  'aiOnboarding.step1.nifHint': 'Компания нөмірін келесі қадамда сұраймыз.',
  'aiOnboarding.step1.nifGo': 'Нөмір қадамына өту',
  'aiOnboarding.step1.nifNoStep': 'Мұнда компания нөмірі керек емес: не жеткізетініңізді жазыңыз.',
  'aiOnboarding.quota.counter': '{{limit}} ЖИ-іздеудің {{left}} қалды',
  'aiOnboarding.quota.left': '{{n}} {{word}} қалды. Pro-да — айына 15.',
  'aiOnboarding.quota.word.one': 'ЖИ-іздеу',
  'aiOnboarding.quota.word.few': 'ЖИ-іздеу',
  'aiOnboarding.quota.word.many': 'ЖИ-іздеу',
  'aiOnboarding.step2.title': 'Не шыққанын тексеріңіз',
  'aiOnboarding.step2.byAi': 'Сипаттама бойынша ЖИ ұсынды — кодтарды тексеріңіз.',
  'aiOnboarding.row.categories': 'Санаттар',
  'aiOnboarding.row.subject': 'Санаттар, ЕНС ТРУ және тауашалар',
  'aiOnboarding.row.ikpu': 'ЕНС ТРУ кодтары',
  'aiOnboarding.row.niches': 'Тауашалар',
  'aiOnboarding.row.keywords': 'Сөздер',
  'aiOnboarding.row.regions': 'Өңірлер',
  'aiOnboarding.row.excludes': 'Алып тастау',
  'aiOnboarding.counts': 'Қазір {{open}} ашық лот · күніне {{perDay}} жаңа',
  'aiOnboarding.locked': 'тағы {{n}} {{word}} — Pro-да',
  'aiOnboarding.code.one': 'код',
  'aiOnboarding.code.few': 'код',
  'aiOnboarding.code.many': 'код',
  'aiOnboarding.save': 'Сақтау және хабарламалар алу',
  'aiOnboarding.saving': 'Сақтап жатырмыз…',
  'aiOnboarding.saveError': 'Іздеуді сақтау мүмкін болмады. Қайталап көріңіз.',
  'aiOnboarding.edit': 'Өзгерту',
  'aiOnboarding.chipRemove': 'Алып тастау: {{label}}',
  'aiOnboarding.chipAdd': 'Қосу: {{label}}',
  'aiOnboarding.addWord': 'қосу',
  'aiOnboarding.aiMark': 'ЖИ толтырды',
  'aiOnboarding.notUnderstood.title': 'Сипаттаманы түсінбедім',
  'aiOnboarding.notUnderstood.desc':
    'Не жеткізетініңізді нақтылаңыз — мысалы, «сорғылар және оларға қосалқы бөлшектер». Немесе санатты қолмен таңдаңыз.',
  'aiOnboarding.notUnderstood.refine': 'Нақтылау',
  'aiOnboarding.notUnderstood.manual': 'Санатты таңдау',
  'aiOnboarding.tinUnknown.desc':
    'Сіздің {{tin}} бойынша деректер таппадық. Не жеткізетініңізді сипаттаңыз — хабарламаларды сипаттама бойынша таңдаймыз.',
  'aiOnboarding.broad.title': 'Тым кең: {{n}} ашық лот',
  'aiOnboarding.broad.desc':
    'Хабарламаларға каталогтың барлығы дерлік түседі. Сөз немесе өңір қосыңыз — нақтырақ болады.',
  'aiOnboarding.broad.narrow': 'Тарылту',
  'aiOnboarding.broad.keep': 'осылай қалдыру',
  'aiOnboarding.broad.budgetChip': '{{amount}} бастап',
  'aiOnboarding.none.title': 'Қазір сәйкес лоттар жоқ',
  'aiOnboarding.none.desc':
    'Іздеуді сақтап, алғашқы лот туралы хабарлаймыз. Мұндай сұраныстар бойынша бұл әдетте айына 1–2 рет.',
  'aiOnboarding.none.save': 'Сақтау және күту',
  'aiOnboarding.none.widen': 'Кеңейту',
  'aiOnboarding.widened.title': 'Лоттар келуі үшін таңдау кеңейтілді',
  'aiOnboarding.widened.desc': 'Нақты сұраныс бойынша қазір ашық лоттар: {{n}}. Не өзгерді:',
  'aiOnboarding.widened.class':
    'кодтар — сыныпқа дейін (алғашқы 6 цифр): сол тауардың көрші позициялары да келеді',
  'aiOnboarding.widened.category': 'санат қосылды — оның таңдаудағы сөздері бар лоттары келеді',
  'aiOnboarding.widened.budget': 'бюджеттің төменгі шегінсіз',
  'aiOnboarding.widened.regions': 'бүкіл ел бойынша, өңірсіз',
  'aiOnboarding.widened.restore': 'Қайтару:',
  'aiOnboarding.quotaOut.title': 'ЖИ-іздеулер таусылды',
  'aiOnboarding.quotaOut.desc':
    'Екі тегін таңдау пайдаланылды. Іздеуді қолмен құрастыруға болады — немесе Pro ашыңыз, онда айына 15 таңдау.',
  'aiOnboarding.quotaOut.descMonth':
    'Осы айдағы таңдаулар пайдаланылды. Іздеуді қолмен құрастыруға болады — жаңалары ай басында пайда болады.',
  'aiOnboarding.quotaOut.manual': 'Қолмен құрастыру',
  'aiOnboarding.quotaOut.pro': 'Pro ашу',
  'aiOnboarding.error.title': 'ЖИ жауап бермеді',
  'aiOnboarding.error.desc':
    'Модель әдеттегіден ұзақ үндемей тұр немесе қате қайтарды — кәдімгі санат таңдауын ашамыз, әрекет есептелмейді.',
  'aiOnboarding.error.manual': 'Санатты таңдау',
  'aiOnboarding.error.retry': 'Қайталау',
  'aiOnboarding.manualFooter': 'Санатты қолмен таңдау қолжетімді — ЖИ жалғыз жол емес.',
  'aiOnboarding.fill.title': 'Не керегін сипаттаңыз — ЖИ өрістерді толтырады',
  'aiOnboarding.fill.placeholder':
    'сорғылар мен электр қозғалтқыштар керек, Алматы және облыс, 5 млн бастап',
  'aiOnboarding.fill.submit': 'ЖИ-мен толтыру',
  'aiOnboarding.fill.filled': 'ЖИ толтырды — әдеттегідей өзгертуге болады',
  // Chile (cl)
  'plans.vat.includedCl': '· ҚҚС кіреді',
  'plans.vat.includedBreakdown': 'Оның ішінде {{vat}} ҚҚС ({{rate}} %)',
  'plans.cardOnlyPriceVatIncluded': '{{amount}} / ай · ҚҚС кіреді',
  // Chile (cl) — rendered on the Liciora build only.
  'plans.receiptCl':
    'Email-ге төлем түбіртегі келеді; төлеген кезде RUT пен компания атауын көрсетсеңіз, олар онда болады. SII электрондық фактурасын бермейміз.',
  'billing.stripe.receiptCl':
    'Email-ге төлем түбіртегі келеді. SII электрондық фактурасын бермейміз.',
} as const;
